webpackJsonp([1],{

/***/ "1CzY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3jmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BsmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24df150c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("wc2M")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-24df150c"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98a8f3fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("1CzY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5929a412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("BsmF")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutubeOrOlympics: function isYoutubeOrOlympics() {
      return this.videoURL.search('youtube') !== -1 || this.videoURL.search('olympic') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c81c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutubeOrOlympics)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("3jmS")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35db5a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("dUvF")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Revue Olympique - Numéro 125",
  "shortTitle": "",
  "description": "",
  "width": 744,
  "height": 921,
  "currentLanguage": "FR",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/125"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/125"
  }],
  "basePath": "/125",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://olympic-review.s3-website-eu-west-1.amazonaws.com/125/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 1-title-1\" style=\"top:14px;left:1px;\" src=\"/125/static/_content/1-title-1.png\"/>\n        <img class=\"abs halfScale 1-title-2\" style=\"top:11px;left:244px;\" src=\"/125/static/_content/1-title-2.png\"/>\n        <img class=\"abs halfScale 1-header\" style=\"top:136px;left:231px;\" src=\"/125/static/_content/1-title-3.png\"/>\n        <img class=\"abs halfScale 1-date\" style=\"top:136px;left:605px;\" src=\"/125/static/_content/1-date-1.png\"/>\n        \n        <img class=\"abs halfScale 1-subtitle\" style=\"top:323px;left:29px;\" src=\"/125/static/_content/1-subtitle-1.png\"/>\n        <img class=\"abs halfScale 1-subtitle\" style=\"top:437px;left:57px;\" src=\"/125/static/_content/1-sub-1.png\"/>\n        <img class=\"abs halfScale 1-caption\" style=\"top:328px;left:505px;\" src=\"/125/static/_content/1-text-1.png\"/>\n        <img class=\"abs halfScale 1-caption\" style=\"top:387px;left:505px;\" src=\"/125/static/_content/1-text-2.png\"/>\n        <img class=\"abs halfScale 1-caption\" style=\"top:447px;left:505px;\" src=\"/125/static/_content/1-text-3.png\"/>\n\n        <div class=\"addContentLink abs\" style=\"top:891px; left:652px; width:75px; height:14px;\">\n          <a href=\"https://olympics.com/en/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-title-1\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"1-title-2\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"1-header\"), 0.6, {opacity:0, y:-50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"1-date\"), 0.6, {opacity:0, y:50}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.4)\n\n          .fromTo(cOf(\"1-subtitle\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n          .staggerFromTo(cOf(\"1-caption\"), 0.6, {opacity:0, x:50}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.1, 1.8)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympique REVUE  Publication officielle du Mouvement olympique  Des Jeux à l’italienne Milano Cortina 2026 sera une vitrine de l’excellence sportive et de l’héritage culturel des régions hôtes  TM  Décembre 2025 Numéro 125  La fascinante histoire des sports d’hiver dans les Alpes italiennes Des experts livrent leur analyse sur les athlètes qui brilleront cet hiver Sam Reinhart et les autres stars de la NHL partagent leur enthousiasme pour les Jeux  olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 4-title\" style=\"top:118px;left:44px;\" src=\"/125/static/_content/4-title-1.png\"/>\n        <img class=\"abs halfScale 4-title\" style=\"top:184px;left:45px;\" src=\"/125/static/_content/4-sub-1.png\"/>\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7);\" style=\"top:377px; left:53px; width:86px; height:90px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(28);\" style=\"top:483px; left:53px; width:86px; height:67px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(81);\" style=\"top:563px; left:53px; width:86px; height:67px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:293px; left:243px; width:33px; height:47px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8);\" style=\"top:340px; left:243px; width:263px; height:60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(30);\" style=\"top:430px; left:223px; width:136px; height:131px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(40);\" style=\"top:565px; left:223px; width:127px; height:141px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(46);\" style=\"top:591px; left:375px; width:132px; height:114px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(58);\" style=\"top:765px; left:379px; width:139px; height:114px;\"></div>\n\n        <div class=\"addContentLink\" style=\"top:609px;left:548px;width:120px;height:8px\">\n          <a href=\"https://olympics.com/cio\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:617px;left:548px;width:116px;height:8px\">\n          <a href=\"mailto:olympicreview@olympic.org\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Sommaire  SOMMAiRE  COMMISSION EXÉCUTIVE Présidente Kirsty Coventry Vice-présidents Juan Antonio Samaranch, Nawal El Moutawakel, Gerardo Werthein, Baron Pierre-Olivier Beckers-Vieujant Membres Nenad Lalovic, Ivo Ferriani, SAR le Prince Feisal Al Hussein, Mikaela Cojuangco Jaworski, Lingwei Li, Emma Terho, Spyros Capralos, Kristin Kloster, Octavian Morariu  PUBLICATION OFFICIELLE DU MOUVEMENT OLYMPIQUE DÉCEMBRE 2025  REVUE OLYMPIQUE  DOSSIERS  8  BIENVENUE À MILANO CORTINA 2026  7  AVANT-PROPOS  Par la présidente du CIO, Kirsty Coventry.  28 81  AU-DELÀ DES ANNEAUX  DÉCÈS  Milano Cortina 2026 sera une vitrine de l’excellence sportive et de l’héritage culturel des régions hôtes. Découvrez le programme et les sites de compétition.  ISSN : 0251-3498 Imprimée au Royaume-Uni  30  IMAGES Couverture : Marianna Tomaselli/CIO Intérieur : CIO ; CIO/Greg Martin ; CIO/ Arnaud Meylan ; CIO/Lothar Rübelt ; CIO/ Erich Andres ; CIO/Kishimoto ; CIO/Ubald Rutar ; CIO/John Huet ; CIO/Ian Jones ; Olympics.com ; Olympic Channel Services ; comité d’organisation des Jeux Olympiques et Paralympiques d’hiver de Milano Cortina 2026 ; comité d’organisation des Jeux Olympiques et Paralympiques de Paris 2024 ; Roman Tyulyakov/ProAlps ; Foto Ghedina, Cortina d’Ampezzo ; Foto Constantini, Cortina ; Emily Harrop (www.emilyharrop. com) ; Getty Images ; Shutterstock ; Unsplash  LES SPORTS D’HIVER EN ITALIE Sylvain Bolt retrace l’histoire des sports d’hiver dans les Alpes italiennes et la croissance du tourisme dans la région.  40  SKI-ALPINISME  Tous les regards seront braqués sur les pistes de Bormio pour l’introduction du ski-alpinisme dans le programme olympique.  Directeur de la communication institutionnelle et des affaires publiques Christian Klaue Rédactrice en chef Katharine Mann Corédactrice en chef et édition française Lucile Tonnerre Édition espagnole Dolores Blázquez Édition italienne Mari Balsama Wilson Agence de production Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Conor Ketley Design Liz Rankin, Shyama Rajani, Apostolis Tatasopoulos, Jen Thich Retouche d’image Liz Rankin Secrétariat de rédaction Quentin Huon Traduction Aurélien Sagnier, Indira Akanni, Michèle Salvat, Catherine Brusa Relecture Nathalie Herrmann  CONTACTS  46  À TRAVERS L’OBJECTIF  Retour en images sur la riche histoire de la diffusion des Jeux Olympiques au fil des 90 dernières années.  58  LES ATHLÈTES  Des joueurs de la NHL aux olympiens et nouveaux venus, experts et athlètes partagent leurs attentes pour les Jeux.  Écrivez-nous à : La Revue Olympique, Département de la communication institutionnelle et des affaires publiques, Maison Olympique, 1007 Lausanne, Suisse Site internet : www.olympics.com/cio E-mail : olympicreview@olympic.org Tél. : +41 (0)21 621 61 11 La Revue Olympique est imprimée sur du papier certifié PEFC fabriqué à partir de bois de forêts gérées dans le souci du développement durable. La Revue Olympique est publiée par le Comité International Olympique. Les articles publiés dans la Revue Olympique ne reflètent pas nécessairement les opinions du CIO. Toute reproduction sans l’accord du département de la communication institutionnelle et des affaires publiques du CIO est interdite. La terminologie olympique (en particulier OlympiquesTM et Jeux OlympiquesTM) et les autres propriétés olympiques sont des marques déposées (TM) appartenant au CIO. Pour de plus amples informations sur la protection des propriétés olympiques, veuillez consulter le site : olympics.com.  Toutes les informations sont correctes au moment de l’impression.  4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "omegawatches.com  CÉLÉBRONS MILANO CORTINA 2026 En tant que Chronométreur Officiel des Jeux Olympiques d’hiver, OMEGA présente la Speedmaster 38 mm créée spécialement pour Milano Cortina 2026. Doté d’un médaillon estampillé sur le fond de boîte, ce modèle se distingue par son cadran verni blanc neige. Il est rehaussé d’un motif bleu givré, assorti à une trotteuse centrale aux délicates nuances dégradées. Inspiré de l’emblème de la compétition, ce garde-temps rend hommage à cet événement sportif historique dans un style intemporel."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 7-title\" style=\"top:100px;left:45px;\" src=\"/125/static/_content/7-title-1.png\"/>\n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:795px; left:494px; height:69px; width:100px; background-color:#ffffff\"></div>\n\n        <a href=\"https://www.olympics.com/cio/milano-cortina-2026\" target=\"_blank\" class=\"addContentLink\" style=\"top:283px; left:335px; width:119px; height:14px;\"></a>\n        <a href=\"https://www.olympics.com/cio/milano-cortina-2026\" target=\"_blank\" class=\"addContentLink\" style=\"top:297px; left:267px; width:116px; height:14px;\"></a>\n\n        <a href=\"https://www.olympics.com/cio/jeux-olympiques/alpes-francaises-2030\" target=\"_blank\" class=\"addContentLink\" style=\"top:98px; left:658px; width:33px; height:14px;\"></a>\n        <a href=\"https://www.olympics.com/cio/jeux-olympiques/alpes-francaises-2030\" target=\"_blank\" class=\"addContentLink\" style=\"top:112px; left:490px; width:78px; height:14px;\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.staggerFromTo(cOf(\"7-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1)\n          .fromTo(idOf(\"7-sig\"), 0.8, {width:155,x:0}, {width: 0,x:167, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.3)\n        }\n\n      function onPageLeave() {\n        removeContentLinks();\n        pg7Anim.stop();\n        }\n      ",
    "searchText": "Revue Olympique  7  Numéro 125  AVANT-PROPOS DE KiRSTY COVENTRY D  1 Les Jeux Olympiques d’hiver font leur retour dans le nord de l’Italie, une région souvent considérée comme l’un des berceaux des sports d’hiver.  1  ans quelques semaines à peine, tous les regards seront braqués sur le nord de l’Italie, qui accueillera les meilleurs athlètes des sports d’hiver au monde à l’occasion des Jeux Olympiques d’hiver de Milano Cortina 2026. Ce seront les premiers Jeux de ma présidence et je suis très heureuse qu’ils se déroulent dans un pays qui a la passion chevillée au corps. L’Italie est célèbre pour ses paysages, sa culture, sa gastronomie et son inﬂuence sur la mode. Mais sa plus grande richesse réside sans doute dans ses habitants : leur chaleur, leur sens de la communauté et leur hospitalité. Autant d’atouts qui feront le bonheur des athlètes, des fans présents et des téléspectateurs du monde entier. L’Italie organise ses quatrièmes Jeux Olympiques et ses troisièmes Jeux d’hiver, dans une région souvent considérée comme l’un des berceaux des sports d’hiver. Dans ce numéro de la Revue Olympique, nous mettons en avant les athlètes qui se préparent à écrire l’histoire sur la neige et la glace. Des athlètes féminines qui mènent la charge de la délégation des États-Unis à leurs homologues italiens qui espèrent briller devant leur public, en passant par les athlètes  français qui auront déjà l’édition des Alpes françaises 2030 en vue : ces pages regorgent d’histoires passionnantes. Nous avons tendu le micro à la championne française Emily Harrop qui se prépare pour les débuts olympiques du ski-alpinisme, mais aussi à des ﬁgures majeures des sports d’hiver telles que l’Australien Scotty James, le Sud-Coréen Cha Junhwan, l’Italienne Flora Tabanelli et la légende française du biathlon Martin Fourcade. Et alors que la NHL s’apprête à faire son grand retour aux Jeux après plus d’une décennie d’absence, Sam Reinhart (Florida Panthers) conﬁe son impatience de représenter le Canada à Milan et d’affronter ses coéquipiers de la NHL sur la scène olympique dans un entretien exclusif. Inspiré par la devise des Jeux « IT’s Your Vibe », un article vous plonge au cœur d’une Italie où culture, gastronomie et mode se mêlent à l’esprit de l’événement. Le slogan invite chacun – participants comme spectateurs – à insuffler sa propre énergie, tandis que l’identité visuelle, l’art, le design et l’hospitalité reﬂètent le dynamisme et la diversité des régions hôtes. Des concepts novateurs pour la torche et les médailles, une Olympiade culturelle qui s’étend à tout le pays et un hommage à la cuisine et à la mode italiennes : Milano Cortina 2026 vise à révéler l’Italie au-delà des stéréotypes – où la créativité, l’accueil et une touche personnelle déﬁnissent l’expérience olympique et le pays lui-même. Enﬁn, la Revue Olympique propose une analyse historique détaillée sur le lien entre le développement des sports d’hiver en Italie et dans les Alpes et l’industrie touristique ﬂorissante de la région, qui demeure aussi dynamique aujourd’hui qu’il y a un siècle. Milano Cortina 2026 mettra en lumière cet héritage, aux côtés de sites et paysages emblématiques répartis sur 22 000 km², reﬂets d’une tradition d’excellence. Où que vous soyez dans le monde, je vous invite à célébrer avec nous le début de l’année 2026 sur la neige et la glace du nord de l’Italie. ■  Kirsty Coventry, présidente du CIO"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 9-title\" style=\"top:196px;left:39px;\" src=\"/125/static/_content/9-title-1.png\"/>\n        <img class=\"abs halfScale 9-title\" style=\"top:283px;left:51px;\" src=\"/125/static/_content/9-title-2.png\"/>\n        <img class=\"abs halfScale 9-sub\" style=\"top:386px;left:55px;\" src=\"/125/static/_content/9-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.staggerFromTo(cOf(\"9-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"9-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.5)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg9Anim.stop();\n        }\n      ",
    "searchText": "Au sommet  DU MONDE LES JEUX OLYMPIQUES SERONT UNE VITRINE DíEXCELLENCE SPORTIVE DANS UNE R…GION QUI ENTRETIENT DEPUIS LONGTEMPS UNE PASSION POUR LES SPORTS DíHIVER. PAR GAIA LUTZ  En ski acrobatique, les épreuves de bosses seront parmi les événements les plus spectaculaires des Jeux de Milano Cortina 2026."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "10  Au sommet du monde  1  D  «  e l’aspect créatif à la sécurité en passant par le sport, la culture, les finances et le design : rien n’échappe aux Jeux Olympiques. Ils sont le reflet d’une société dans son ensemble à un moment donné », déclare Christophe Dubi, directeur exécutif des Jeux Olympiques du CIO. C’est une affirmation audacieuse, mais à l’image des Jeux eux-mêmes. Et en 2026, l’ampleur du travail entrera dans une nouvelle dimension, du moins géographiquement parlant. Répartis sur 22 000 km² au nord de l’Italie, les Jeux Olympiques de Milano Cortina 2026 seront les plus étendus de l’histoire olympique : des rues animées de Milan aux pics tranquilles de Livigno à la frontière suisse, de la station glamour de Cortina d’Ampezzo à un  amphithéâtre romain à Vérone – et bien plus encore. Au-delà des exploits sportifs, ces Jeux offriront un modèle innovant d’accueil, en rassemblant des régions aux profils économiques, linguistiques (trois langues sont parlées rien que dans le Tyrol du Sud) et culturels variés, le tout convergeant dans une étreinte olympique commune. « Cette diversité est particulièrement intéressante », estime Christophe Dubi. L’étendue géographique sans précédent de Milano Cortina 2026 n’est pas née d’un désir d’expansion, mais d’un besoin de diminuer l’empreinte des Jeux. Conformément aux réformes de l’Agenda olympique, cette édition s’appuie sur les infrastructures existantes pour livrer une édition plus durable. Les Jeux s’adaptent au contexte local, au lieu de le  refaçonner. Cette vision a été formidablement incarnée lors des Jeux de Paris 2024, où des sites temporaires ont été érigés autour des lieux les plus iconiques de la capitale : la Seine, la tour Eiffel ou la place de la Concorde. Pour Milano Cortina, le même principe s’appliquera, mais de manière bien différente. Si Paris a amené la compétition au cœur d’une métropole urbaine dense, les Jeux d’hiver italiens seront répartis sur plusieurs vallées du nord du pays, épousant l’amour historique de la région pour les sports d’hiver. Des Coupes du monde de ski alpin aux Championnats du monde de biathlon, en passant bien entendu par les Jeux Olympiques d’hiver de Cortina d’Ampezzo 1956, les territoires de Milano Cortina 2026 sont d’ores et déjà prêts pour les compétitions hivernales."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 11-quote\" style=\"top:502px;left:269px;\" src=\"/125/static/_content/11-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim.fromTo(cOf(\"11-quote\"), 1, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1)}, 1)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          pg11Anim.stop();\n        }\n      ",
    "searchText": "Revue Olympique  11  Numéro 125  2  « L’Italie abrite l’une des plus vastes portions des Alpes. Certains l’associent naturellement à la Méditerranée et aux villes qui regorgent d’œuvres d’arts, mais les traditions et sports de montagne font partie intégrante de notre culture », explique Andrea Varnier, directeur général du comité d’organisation (COJO) de Milano Cortina 2026. Ajoutez-y l’expérience de Milan dans l’organisation de grands événements – Fashion Week et salons du design, finales de la Ligue des champions de l’UEFA ou encore Exposition universelle de 2015 –, la ville lombarde possède des infrastructures parfaitement taillées pour recevoir ces Jeux. Elle foisonne également d’expertise humaine : plusieurs membres du COJO de Milano Cortina 2026 ont travaillé sur les Jeux Olympiques d’hiver de Turin 2006. « C’est plutôt inhabituel d’accueillir les Jeux deux fois dans votre pays dans une même vie professionnelle », souligne Andrea Varnier, qui signale que même les bénévoles possèdent beaucoup d’expérience : plus de la moitié des 120 000 candidats ont déjà travaillé sur des événements sportifs internationaux.  ´ LES TRADITIONS ET SPORTS DE MONTAGNE FONT PARTIE INT…GRANTE DE NOTRE CULTURE. ª Andrea Varnier Si l’usage des installations se veut plus rationnel, l’impact de l’accueil d’épreuves sur ces sites est gigantesque. Pour Milano Cortina 2026, plusieurs épreuves feront leur retour dans leur « foyer spirituel », des lieux qui ont façonné des légendes et inspiré des générations. « Beaucoup d’athlètes pourront gagner le “Wimbledon” de leur sport et c’est très rare », note Pierre Ducrey, directeur des sports du CIO. Lorsque les biathlètes traverseront les forêts bordant le stade de biathlon d’Anterselva, skis aux pieds et carabine dans le dos, ils auront conscience d’arriver dans le temple de leur  1 Le patinage de vitesse sur piste courte sera à l’honneur à la patinoire de Milan. 2 Les biathlètes traverseront les forêts bordant l’iconique stade de biathlon d’Anterselva."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "12  Au sommet du monde  sport, où l’écho des claquements des tirs retentit depuis plus de 50 ans. Et lorsque les skieurs alpins dévaleront la piste Stelvio de Bormio, l’une des descentes les plus abruptes et exigeantes au monde, ils découvriront pourquoi ce tracé démarque depuis longtemps les audacieux des véritables champions. De la même manière, l’Olimpia delle Tofane, baptisée la « Reine de la vitesse », attend les athlètes avec ses larges courbes et ses lignes plongeantes pour sacrer l’élite olympienne, comme elle l’a fait il y a 70 ans à Cortina d’Ampezzo. Même le centre de glisse de Cortina, l’une des rares infrastructures bâties pour l’occasion, perpétue cette impression de retour : construit sur le site de l’ancienne piste, il va raviver la passion locale pour le bobsleigh, la luge et le skeleton, autant de sports qui ont autrefois défini l’identité hivernale de la ville.  1  Pour les athlètes, ces sites sont bien plus qu’un cadre pittoresque : ils représentent le summum de leur discipline – les pentes les plus difficiles, les pistes les plus rapides et les publics les plus fervents. « Il n’y a rien de tel que d’aller sur un site rempli de spectateurs qui connaissent votre sport », déclare Kaveh Mehrabi, olympien et désormais directeur du département des athlètes du CIO. (Il sait de quoi il parle : il a participé aux Jeux Olympiques de Beijing 2008, dans un pays où son sport, le badminton, attire l’un des publics les plus passionnés.) Ce qui rendra les Jeux de Milano Cortina 2026 aussi attirants, c’est qu’ils ne seront pas seulement une vitrine d’excellence sportive, mais aussi une sorte de pèlerinage, en amenant les meilleurs athlètes du monde dans le berceau de leur sport. Pour le ski-alpinisme,  qui vivra ses premiers Jeux, le symbole est également fort : il se déroulera sur les sommets qui ont façonné cette discipline. Évidemment, tous les sports ne puisent pas leurs racines en Italie, mais ces «(nouveautés » font partie de l’excitation ambiante. Les sports de glace, moins ancrés dans la culture du pays, trouveront une enceinte dédiée à Milan, une ville synonyme d’innovation et de réinvention. Les athlètes y concourront au rythme unique de la ville, mêlant dynamisme, élégance et avant-gardisme.  1 La piste de ski Olimpia delle Tofane accueillera des épreuves olympiques pour la première fois en 70 ans. 2 Les sommets des Dolomites s’embrasent sous l’effet de l’emblématique enrosadira. 3 Les patineurs artistiques s’affrontent lors d’une épreuve test à la patinoire de Milan."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "13  2  3  Le patinage de vitesse se déroulera pour la première fois sur un site temporaire au cœur des pavillons de Fiera Milano Rho – le site de la Foire de Milan plus connu pour accueillir la Milan Design Week et de nombreuses conférences – transformé en anneau de glace olympique pour l’occasion. Le hockey sur glace, quant à lui, bénéficiera d’une arène flambant neuve qui deviendra une salle de concert majeure après les Jeux. Même le village olympique a été construit en prévision de sa reconversion : il se transformera en logements étudiants très attendus, dynamisant un quartier construit sur un ancien site de triage ferroviaire et qui devrait devenir le prochain cœur culturel de Milan. « L’histoire de Milano Cortina est magnifique(: certains sports font leur retour dans leur foyer ancestral, tandis que d’autres se forgent une nouvelle identité urbaine(», note Pierre Ducrey. L’étendue de Milano Cortina 2026 génère un ensemble unique de puzzles logistiques. L’organisation de Jeux avec de telles distances entre les sites n’est pas une tâche facile, surtout dans des conditions hivernales. Tout doit être chorégraphié pour fonctionner parfaitement pour les athlètes comme pour le public. Chaque pôle possèdera son propre village olympique et ses équipements, tandis que les sports seront regroupés pour attirer des publics similaires. Loin de donner la sensation d’un événement fragmenté, chaque territoire doit devenir un microcosme autonome des Jeux dans leur ensemble. « Lors de ces Jeux, nous démontrerons que peu importe la taille du territoire dans lequel vous opérez, vous serez sous un même toit, unis par un souffle unique – celui des Jeux Olympiques », souligne Christophe Dubi. Ce modèle ouvre de nouvelles opportunités pour l’Italie et les futurs hôtes : l’héritage des Jeux peut avoir de vastes répercussions, pour toucher des villages ou des communautés montagnardes rarement présentes sur la scène internationale. Pour les spectateurs qui voyageront en Italie et les téléspectateurs à domicile, ce sera l’occasion de découvrir des lieux cachés, loin des villes connues, et de vivre par exemple l’enrosadira des Dolomites, lorsque les roches luisent de rose et d’orange à l’aube, de goûter la gastronomie d’altitude du Tyrol du Sud, ou de se prélasser dans les bains romains centenaires de Bormio, avec vue sur les montagnes enneigées."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 14-quote\" style=\"top:111px;left:45px;\" src=\"/125/static/_content/14-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-quote\"), 1, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1)}, 1)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          pg14Anim.stop();\n        }\n      ",
    "searchText": "14  Au sommet du monde  ´ [LES JEUX] PEUVENT TRANSMETTRE DES MESSAGES POSITIFS ET PLANTER DES GRAINES POUR L’AVENIR. ª  Andrea Varnier  « Non seulement ce sont des endroits sublimes qui méritent d’être connus, mais beaucoup possèdent des stratégies de tourisme très sophistiquées », ajoute Christophe Dubi. L’un des éléments fédérateurs de ces expériences diverses sera la cérémonie d’ouverture des Jeux. Pour la première fois, elle se déroulera dans plusieurs régions, à l’aide de technologies et de créativité pour relier le site principal – le stade olympique de San Siro à Milan – à Cortina, Livigno et Predazzo. Vrai  1  défi en matière de production, ce format permettra d’unir les différents pôles et de faire participer plus d’athlètes avant le début de leurs épreuves respectives. Par ailleurs, des festivals, expositions et événements culturels contribueront à créer du lien, en embrasant les villages montagnards de l’esprit olympique. « La connexion aux autres est nécessaire : chacun à Cortina doit pouvoir vivre ce qui se déroule à Milan ou Livigno chaque jour et soir, explique Christophe Dubi. Nos téléphones  nous y aident, bien sûr, tout comme le feront les écrans géants sur les places, pour transmettre la frénésie de Milan à Cortina – et vice versa. » Si Milano Cortina 2026 permettra de braquer la lumière sur la diversité de ses territoires, une partie de son héritage consistera à lier encore davantage les lieux et leurs réalités. Pendant des décennies, l’histoire des Alpes a surtout consisté en une migration : les habitants quittant les montagnes pour explorer des opportunités en ville. Ces Jeux proposeront une vision différente, qui redéfinit la relation entre les montagnes et la ville, dans une approche plus équilibrée et durable, où l’une ne domine ni ne vide l’autre de sa substance et où l’unicité de chacune peut bénéficier à l’autre. « Si les Jeux Olympiques ne résolvent pas les guerres, les problèmes environnementaux ou le dépeuplement de certains villages montagnards, conclut Andrea Varnier, ils peuvent transmettre des messages positifs et planter des graines pour l’avenir. » ■ 1 À Milan, les célébrations marquant le J-365 ont inclus une démonstration de hockey sur glace."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Corona Cero 0.0% ABV. ©2026 AB InBev UK Limited, all rights reserved."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 17-title\" style=\"top:86px;left:272px;\" src=\"/125/static/_content/17-title-1.png\"/>\n        <img class=\"abs halfScale 17-title\" style=\"top:197px;left:315px;\" src=\"/125/static/_content/17-title-2.png\"/>\n        <img class=\"abs halfScale 17-title\" style=\"top:293px;left:425px;\" src=\"/125/static/_content/17-title-3.png\"/>\n        <img class=\"abs halfScale 17-sub\" style=\"top:447px;left:269px;\" src=\"/125/static/_content/17-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim.staggerFromTo(cOf(\"17-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"17-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg17Anim.stop();\n        }\n      ",
    "searchText": "IT's Your Vibe LES JEUX OLYMPIQUES DíHIVER DE MILANO CORTINA 2026 SERONT LíOCCASION DíUNE C…L…BRATION QUI FERA R…SONNER L'EXCELLENCE SPORTIVE AUTANT QUE LE RICHE PATRIMOINE CULTUREL DES R…GIONS LOCALES ET DE TOUT LE PAYS. PAR GAIA LUTZ  N  «  ous serons tous d’accord pour reconnaître que l’Italie détient, d’une manière ou d’une autre, le secret de la beauté », déclare Yiannis Exarchos, directeur général des services olympiques de radio-télévision (Olympic Broadcasting Services – OBS). C’est un bel hommage, en particulier venant d’un Grec, mais quiconque a foulé le sol italien comprend pleinement la vérité de ces mots. Peu d’endroits éveillent autant les sens qu’il bel paese, une terre qui, depuis des millénaires, façonne notre conception de l’esthétique. À chaque édition des Jeux, un tel héritage est à la fois une bénédiction et un défi. Il offre une source d’inspiration infinie, mais apporte son lot de stéréotypes. Lorsque les caméras de Yiannis Exarchos se tourneront vers Milano Cortina 2026 en février, chaque spectateur arrivera déjà avec sa propre vision de l’Italie. Même ceux qui n’y ont jamais posé le pied portent en eux ses éclats culturels : des cartes postales de ruines romaines aux chefs-d’œuvre de la Renaissance, de la silhouette sculpturale d’une Ferrari à la fantaisie onirique de Fellini, jusqu’à la poésie discrète d’une Vespa étincelant au soleil et le charme simple d’un plat de pâtes sur une nappe à carreaux rouge et blanche. Le défi pour Milano Cortina 2026 sera d’honorer ce précieux patrimoine culturel tout en révélant une Italie nouvelle – une Italie"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "18  IT’s Your Vibe  vivante. Car si l’Italie est souvent perçue comme une galerie d’images splendides, ce qui fait chavirer les cœurs, c’est l’énergie qui l’anime. « Nous voulions évoquer la beauté italienne comme une émotion qui dépasse le visible – une chaleur, un élan, une lumière intérieure », confie Raffaella Paniè, directrice de la marque, de l’identité et de l’esthétique des Jeux de Milano Cortina 2026, chargée de traduire cet esprit en langage visuel. Le résultat ? Une « Identité visuelle des Jeux » définie par le mouvement et non par l’image : des amis discutant avec les mains, un maestro faisant résonner la musique d’un geste de bras, ou encore un pizzaiolo faisant danser la pâte dans les airs ou un skieur traçant son empreinte sur le flan de la montagne – l’idée était de capturer ces gestes humains qui incarnent les talents et les succès de tout un pays. L’emblème apparaît comme tracé du bout des doigts sur une vitre embuée ; les pictogrammes, dessinés d’un seul trait fluide, évoquent les mouvements des athlètes. Un nouvel élément graphique, les « Vibes », prend le pouls du sport et le traduit en couleurs et en formes géométriques. Les avant-gardistes italiens – Lucio Fontana, Carlo Mollino, Ettore Sottsass – ont inspiré la direction créative, mais surtout l’esprit : une émotion transformée en forme, en couleur et en énergie. « L’Italie incarne dynamisme, audace et modernisme », affirme Raffaella Paniè, en évoquant les mascottes des Jeux, Milo et Tina, dont la fantaisie reflète bien cette vitalité. Fidèle à cette énergie italienne, la devise de Milano Cortina 2026, « IT’s Your Vibe », ressemble moins à un slogan qu’à une invitation. « Plutôt que d’imposer une image, nous voulons offrir un cadre où chacun puisse projeter ses propres émotions et perceptions des Jeux », insiste Raffaella Paniè. Cette devise remet les personnes – athlètes, bénévoles, visiteurs et habitants – au cœur de l’expérience, invitant le monde entier à ressentir l’énergie qui anime Milano Cortina 2026 et à en devenir acteur. Dans cet élan qui valorise les êtres et les lieux, elle vise également à révéler une Italie allant au-delà des stéréotypes : une Italie où traditions hivernales et culture méditerranéenne coexistent, où la gastronomie s’affirme bien au-delà des pizzas et des pâtes et où une nouvelle génération de créateurs – artistes, designers et chefs – redonne un souffle nouveau aux arts intemporels du pays.  1  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 19-title\" style=\"top:128px;left:169px;\" src=\"/125/static/_content/19-title-1.png\"/>\n        <img class=\"abs halfScale 19-title\" style=\"top:184px;left:265px;\" src=\"/125/static/_content/19-title-2.png\"/>\n\n        <a href=\"https://www.olympics.com/fr/milano-cortina-2026/iconic-posters\" target=\"_blank\" class=\"addContentLink\" style=\"top:655px; left:479px; width:50px; height:14px;\"></a>\n        <a href=\"https://www.olympics.com/fr/milano-cortina-2026/iconic-posters\" target=\"_blank\" class=\"addContentLink\" style=\"top:669px; left:415px; width:98px; height:14px;\"></a>\n        <a href=\"https://www.olympics.com/fr/milano-cortina-2026/iconic-posters\" target=\"_blank\" class=\"addContentLink\" style=\"top:683px; left:415px; width:63px; height:14px;\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.staggerFromTo(cOf(\"19-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg19Anim.stop();\n        }\n      ",
    "searchText": "19  Numéro 125  Art et culture 1 Les affiches emblématiques pour les Jeux Olympiques et Paralympiques. 2 La cérémonie de clôture se déroulera dans les arènes de Vérone, réputées pour accueillir des événements culturels de renommée mondiale. 3 Le danseur de légende Roberto Bolle participe à l’Olympiade culturelle.  3  S  i la devise de Milano Cortina 2026 était une image, elle ressemblerait probablement à l’affiche emblématique des Jeux. Réalisée par la célèbre illustratrice italienne Olimpia Zagnoli, dans le style audacieux qui est sa signature, Visione Olimpica représente le visage d’un personnage arborant les anneaux olympiques en guise de lunettes, avec des montagnes en toile de fond et des clins d’œil à l’élégance italienne. En somme, le spectateur est celui autour duquel s’orchestre la symphonie olympique. « L’idée est de célébrer non seulement les athlètes, mais aussi chaque spectateur dans sa singularité », explique Olimpia Zagnoli, en écho à l’esprit participatif de « IT’s Your Vibe ». De même, les affiches artistiques de Milano Cortina 2026 célèbrent la participation et la diversité des perspectives que chacun apporte aux Jeux. Dix jeunes artistes ont été sélectionnés pour proposer leur interprétation personnelle de Milano Cortina 2026 à travers 10 affiches (cinq dédiées aux Jeux Olympiques et cinq aux Jeux Paralympiques). « Nous voulions mettre en lumière la richesse du paysage artistique italien et la diversité  des regards portés sur le sport », explique Damiano Gullì, conservateur pour l’art contemporain et les programmes publics à la Triennale de Milan, partenaire du comité d’organisation pour la création de l’affiche emblématique et de celles artistiques. La collection qui en résulte est un kaléidoscope vibrant, explorant des thèmes tels que le jeu, la communauté et les souvenirs d’enfance associés aux territoires de Milano Cortina 2026. Au-delà des affiches, l’art et le sport entretiennent depuis toujours une complicité aux Jeux Olympiques – des premières éditions, où l’art se voyait décerner des médailles tout comme le sport, jusqu’à l’Olympiade culturelle qui anime aujourd’hui l’événement. Ce programme pluriannuel transforme les Jeux en un véritable festival de créativité à l’échelle nationale. Pour Milano Cortina 2026, il se réinvente en mettant à l’honneur l’art italien. Un cours de ballet public offert par Roberto Bolle au pied du Duomo à Milan, des opéras et des pièces orchestrales créés spécialement pour célébrer les valeurs olympiques, des expositions qui racontent les traditions alpines et même des concours de sculpture sur glace – autant d’expériences qui composent une partie du vaste programme. Investissant musées, théâtres, couvents, châteaux et places publiques des territoires de Milano Cortina 2026, ces événements ont déjà commencé et continueront, tout au long de l’année à venir, à faire rayonner la créativité foisonnante du pays."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 20-title\" style=\"top:148px;left:50px;\" src=\"/125/static/_content/20-title-1.png\"/>\n\n        <a href=\"https://www.olympics.com/cio/news/milano-cortina-2026-devoile-le-parcours-complet-du-relais-de-la-flamme-olympique-x3630?displayAsWebView=true%3FdisplayAsWebView%3Dtrue \" target=\"_blank\" class=\"addContentLink\" style=\"top:417px; left:192px; width:42px; height:14px;\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.staggerFromTo(cOf(\"20-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg20Anim.stop();\n        }\n      ",
    "searchText": "20  IT’s Your Vibe  Design E  n Italie, l’alliance subtile entre forme et fonction a donné naissance à l’une des scènes de design industriel les plus avant-gardistes au monde, transformant des objets du quotidien – bouilloires, tire-bouchons ou automobiles – en véritables icônes qui éveillent les sens. Pour Milano Cortina 2026, cet héritage trouve son expression dans la torche et les médailles olympiques : des objets chargés d’un poids symbolique réinventés grâce à la simplicité et le mouvement. Imaginée par le studio de design Carlo Ratti Associati, la torche « Essential » incarne la sobriété : « Dès le départ, nous avons saisi que l’essentiel n’était pas la torche, mais la flamme. Nous nous sommes demandé comment dépasser la conception de la torche pour mettre en avant la puissance et la beauté de la flamme », confie Carlo Ratti. Le résultat est une œuvre aux lignes d’une pureté qui semble se mouvoir avec le relais de la flamme et dont la surface réfléchissante reflète le ciel, la neige et les visages qui s’y dessinent au passage. Développé par Eni en collaboration avec Versalis et conçue puis fabriquée par Cavagna, « Essential » est entièrement produite en Italie à partir d’aluminium et de laiton recyclés. Une fine ouverture au sommet révèle le mécanisme  interne de la torche. « Le cœur de la torche est sophistiqué et le travail du designer demande de le dissimuler, comme on construit une carrosserie autour d’un moteur », explique Carlo Ratti. « Nous avons voulu réduire au minimum ce qui entoure ce cœur, sans ajouter de formes superflues. » La même quête d’essence a présidé à la conception des médailles de Milano Cortina 2026. Alors que la victoire est souvent représentée comme un moment unique, ces médailles en dévoilent toute la trame. Conçues comme deux moitiés qui se rejoignent, elles symbolisent l’unité indispensable à la victoire – celle qui lie l’athlète à son cercle élargi : coéquipiers, famille, amis et supporters. Cette dualité incarne aussi le caractère inédit de cette édition des Jeux, accueillie pour la première fois par deux villes hôtes. « Nos médailles, célèbrent la force des différences », dit Raffaella Paniè, qui a dirigé l’équipe chargée de la conception. Réalisées en collaboration avec la Monnaie d’État italienne – dont l’école d’art de la médaille forme des maîtres graveurs depuis 1907 –, les médailles en or, argent et bronze associent deux textures : l’une lisse, l’autre granuleuse, rehaussées de bords discrets en relief. Ce contraste crée un effet dynamique, comme si les  médailles s’assemblaient sous nos yeux. « Comme une grande partie de notre identité visuelle, les médailles s’inspirent du geste humain, symbole d’expression et de mouvement », conclut Raffaella Paniè.  1 La torche olympique s’appelle « Essential » en hommage à son design minimaliste. 2 Les médailles de Milano Cortina 2026 s’inspirent du design typiquement italien. 3 Milano Cortina 2026 mettra en lumière une facette riche et méconnue de la gastronomie italienne.  1  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 21-title\" style=\"top:127px;left:227px;\" src=\"/125/static/_content/21-title-1.png\"/>\n        <img class=\"abs halfScale 21-title\" style=\"top:173px;left:273px;\" src=\"/125/static/_content/21-title-2.png\"/>\n\n        <a href=\"https://hospitality.milanocortina2026.org/en?utm_source=web&utm_medium=display&utm_campaign=int_ol_mc26_mc26_ticket_web_hp\" target=\"_blank\" class=\"addContentLink\" style=\"top:544px; left:330px; width:59px; height:14px;\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.staggerFromTo(cOf(\"21-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg21Anim.stop();\n        }\n      ",
    "searchText": "Revue Olympique  21  Numéro 125  t e e n i s i Cu é t i l a t i hosp A  ffirmer son amour pour la cuisine italienne est devenu un cliché, mais en réalité, la « cuisine italienne » n’existe pas vraiment au sens strict. L’identité culinaire du pays se décline en une foule de traditions locales : des plats, des ingrédients et des coutumes qui fluctuent au rythme des villes. « C’est ce qui rend les Jeux de Milano Cortina 2026 si intéressants : l’opportunité de mettre en valeur un patrimoine culinaire d’une richesse exceptionnelle », explique Carlo Zarri, directeur culinaire chez On Location, le fournisseur officiel des services d’hospitalité pour  les Jeux chargé de concevoir des expériences culinaires et des espaces exclusifs pour les invités ayant choisi ses forfaits premium. Des risottos crémeux au safran de Milan – la ville se situe au cœur de la plus vaste région productrice de riz d’Europe – aux salumi et fromages de montagne de la Valteline, sans oublier les influences autrichiennes avec les strudels aux pommes, les dumplings et les vins Lagrein de Bolzano, Milano Cortina 2026 offrira un aperçu unique et méconnu de la richesse gastronomique italienne. « Nous vous assurons que vous ne trouverez ni pâtes  3  alfredo ni amatriciana ici », plaisante Carlo Zarri, qui a mobilisé les écoles culinaires de la région pour former l’équipe de 600 cuisiniers chargés de régaler les invités sur les sites des Jeux. Mais même ceux qui ne bénéficient pas d’un forfait On Location n’auront aucun mal à trouver de bons plats authentiques à travers l’ensemble des territoires de Milano Cortina 2026. L’authenticité est au menu dans de nombreuses régions. Alors que Milan s’est depuis longtemps ouverte à une scène gastronomique cosmopolite, les cités alpines, restées isolées des siècles durant, continuent de servir une cuisine locales. Ici, les recettes se transmettent de génération en génération et les ingrédients se cueillent au gré des saisons : sanglier et cerf parfumés aux herbes sauvages, polenta préparée avec des champignons des bois et des fromages affinés. Le long des pentes, les rifugi – anciens refuges de bergers – ouvrent leurs portes aux visiteurs avec des plats alpins réconfortants. Rustique ne signifie pas pour autant dépourvu de sophistication : ces régions abritent un large éventail de restaurants primés, où les produits du terroir se marient à des"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 22-title\" style=\"top:444px;left:450px;\" src=\"/125/static/_content/22-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.staggerFromTo(cOf(\"22-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg22Anim.stop();\n        }\n      ",
    "searchText": "22  IT’s Your Vibe  techniques raffinées et à une créativité audacieuse. L’hospitalité suit la même philosophie. « Dans ces montagnes, les chaînes hôtelières sont presque inexistantes », souligne Carlo Zarri. « La plupart des hôtels sont gérés par des familles, parfois depuis trois ou quatre générations. » Ici, le luxe se mesure à la touche personnelle : des moniteurs de ski qui ont grandi sur ces pentes et en connaissent chaque courbe, des hôteliers qui dévoilent leurs secrets les mieux gardés et accompagnent leurs hôtes dans des randonnées au cœur des montagnes. Les mondes des podiums et des oreillers sont bien plus liés qu’il n’y paraît : il n’est pas rare de découvrir que l’hôtelier est un ancien olympien ou que celui qui enseigne l’art du virage sur la piste est aussi le propriétaire d’un petit hôtel niché dans la vallée. Deborah Compagnoni – triple médaillée d’or  olympique en ski alpin – dirige un hôtel quatre étoiles avec sa famille dans la Valteline. La famille de Gustav Thöni, légendaire champion olympique de slalom géant, compte parmi les hôteliers chevronnés qui possèdent quatre établissements à Trafoi. À Cortina, Kristian Ghedina – icône locale de ski alpin et olympien – possède un restaurant très apprécié en ville, tandis que son père s’occupe de la gestion de l’un des hôtels historiques de la ville. Entre les compétitions, les spectateurs de Milano Cortina 2026 pourront s’immerger dans des traditions véritablement locales, à travers des expériences uniques – des safaris à ski qui les emmènent d’un lodge à l’autre et des randonnées à cheval à travers les vallées –, ici, le voyage prend un autre sens : c’est le parcours qui compte et non la destination.  2  Mod e I  1  1 De nombreux hôtels locaux sont tenus par des familles. 2 Giorgio Armani entretenait une relation de longue date avec les Jeux Olympiques. 3 Les costumes de la cérémonie de remise des médailles.  l suffit de flâner dans une rue de Milan pour comprendre pourquoi la ville figure parmi les quatre plus grandes capitales mondiales de la mode. Les Italiens ne se contentent pas de porter les vêtements : vestes, jupes et pantalons semblent épouser leur corps, parfaitement ajustés mais portés avec aisance, donnant l’impression que l’élégance, chez eux, est innée. Si Paris séduit par son exubérance, New York par son cosmopolitisme et Londres par son audace expérimentale, l’Italie, elle, brille par son amour du détail, la précision des lignes et son savoir-faire. Milan a vu naître d’innombrables icônes de la mode, mais nul n’a sans doute réinventé la haute couture"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://newsroom.olympics.com/record/1669\" target=\"_blank\" class=\"addContentLink\" style=\"top:781px; left:267px; width:52px; height:14px;\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "23  Revue Olympique  3  comme Giorgio Armani, ce maître qui, en cinq décennies, a transformé la manière de s’habiller. Il Signor Armani, comme on l’appelle avec respect en Italie, nourrissait aussi une véritable passion pour le sport : visage familier des matches de basketball et de football, créateur de collections capsules pour des équipes prestigieuses, et même investisseur engagé dans leur succès. Grâce à sa ligne de vêtements de sport, EA7 Emporio Armani, il habille l’équipe d’Italie pour les Jeux Olympiques depuis Londres 2012. Milano Cortina 2026 s’annonce comme l’aboutissement de cette contribution à l’élégance. « Le sport italien perd une figure d’excellence et un compagnon de route hors du commun. Sa vision du style et de l’élégance a accompagné des générations d’athlètes et  a été l’ambassadrice du Made in Italy aux quatre coins du monde », a commenté Giovanni Malagò, président du comité d’organisation de Milano Cortina 2026, à l’annonce de sa disparition. Un hommage à Armani est prévu lors de la cérémonie d’ouverture : l’équipe d’Italie défilera dans l’une des dernières créations du maître disparu – un élégant ensemble blanc crème, pensé pour incarner, selon ses propres mots, « la simplicité, la clarté et la pureté », valeurs intemporelles du sport. Mais l’influence de la mode italienne à Milano Cortina 2026 ne se limitera pas à la cérémonie, elle s’exprimera également sur l’aire de compétition et en dehors. Des athlètes vêtus de tenues élégantes au style urbain aperçu aussi bien à Milan qu’à Cortina (cette dernière  affichant son propre panache mountain-chic), le style promet d’être un spectacle à part entière, au même titre que le sport. Un autre moment dédié à la mode durant les Jeux se révélera lors de la cérémonie des vainqueurs, à travers les costumes portés par les volontaires qui remettront les médailles sur le podium. Fruit d’un concours entre les principales écoles de mode de Milan, la proposition gagnante a été élaborée par un groupe d’étudiants en première année de master à l’Académie des beaux-arts de Brera. Inspirés par l’identité visuelle des Jeux et l’expressivité du geste italien, les étudiants ont imaginé des ensembles bleus aux lignes classiques réhaussés d’une audace subtile : un liseré doré discret qui effleure les vestes et une touche d’or courant sur les pantalons. « Le bleu est profondément italien et l’or, éclatant et glamour, sont des choix qui conviennent parfaitement pour l’occasion », confie Francesca Liberatore, professeure à Brera et cheffe d’orchestre du groupe. Leurs créations rendent hommage à l’art italien de la confection – des lignes épurées inspirées des silhouettes des années 1950. Pour les hommes, des pantalons droits en laine à coupe ample ; pour les femmes, des vêtements en maille et des pantalons aux détails subtils qui dessinent la taille et célèbrent, comme le souligne Francesca Liberatore, « les silhouettes typiques du sud de l’Italie ».  Les bonnets basco pour hommes, inspirés eux aussi du patrimoine méridional du pays, sont un autre clin d’œil à l’identité régionale. Quant aux matières, elles ont été choisies avec soin pour répondre aux exigences du contexte sportif : laine, tricot, nylon matelassé et bottes robustes adaptées aussi bien aux environnements alpins qu’aux espaces intérieurs. Le résultat : un uniforme qui porte la signature indéniable du Made in Italy – une élégance sobre et un glamour subtil, ce qui incarne le prestige de l’instant tout en laissant les projecteurs là où ils doivent briller : sur les athlètes eux-mêmes. ■  Gaia Lutz est une journaliste brésilienne basée à Lisbonne. Ses reportages l’ont menée aux quatre coins du Portugal, explorant des univers variés : de la scène musicale lusophone effervescente de Lisbonne au paysage créatif du design émergent, en passant par les pratiques agricoles éthiques et durables, sans oublier les portraits d’entrepreneurs et d’artistes qui façonnent l’avenir du pays. Depuis 2021, elle collabore avec le Comité International Olympique sur le projet « Storylines », contribuant à révéler les récits cachés derrière chaque édition des Jeux : design, architecture, mode, gastronomie et voyages."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 24-title\" style=\"top:93px;left:45px;\" src=\"/125/static/_content/24-title-1.png\"/>\n        <img class=\"abs halfScale 24-title\" style=\"top:137px;left:76px;\" src=\"/125/static/_content/24-title-2.png\"/>\n        <img class=\"abs halfScale 24-sub\" style=\"top:183px;left:103px;\" src=\"/125/static/_content/24-sub-1.png\"/>\n\n        <a href=\"https://www.olympics.com/cio/news/milano-cortina-2026-les-sites-italiens-de-classe-mondiale-accueillent-les-jeux-olympiques-d-hiver\" target=\"_blank\" class=\"addContentLink\" style=\"top:181px; left:128px; width:212px; height:14px;\"></a>        \n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.staggerFromTo(cOf(\"24-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"24-sub\"), 0.9, {opacity:0, y:10}, {opacity: 1, y: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg24Anim.stop();\n        }\n      ",
    "searchText": "24  Les cartes des sites  De Milan AUX MONTAGNES DES SITES ET PAYSAGES MAGNIFIQUES OFFRIRONT UN D…COR SUBLIME AUX JEUX DE MILANO CORTINA 2026.  Anterselva/ Antholz  Bormio  Livigno  Vérone Valteline Cortina d’Ampezzo  Milan  Val di Fiemme  Predazzo  CÈrÈmonie díouverture/de clÙture  Tesero"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  25  Numéro 125  BERGAME ET VENISE  MILANO MALPENSA A…ROPORT PRINCIPAL, POINT DíENTR…E OFFICIEL  P‘LE DE VALTELINE ET TIRANO  Milan RHO FIERA  PATINAGE DE VITESSE  TURIN  C…R…MONIE Portello DíOUVERTURE  HOCKEY SUR GLACE  San Siro  CIRTV  PORTA GARIBALDI MILANO CENTRALE  CPP CADORNA  Duomo  HOCKEY SUR GLACE  LINATE AUTRE A…ROPORT  Lodi T.I.B.B.  Site olympique  ROGOREDO  PATINAGE ARTISTIQUE  Station de mÈtro  Autoroute  Cortina Milan  PATINAGE DE VITESSE SUR PISTE COURTE Assago  Village olympique  HÙtel de la famille olympique  Gare  Studios TV  Megastore  GæNES  BOLOGNE ET ROME  Anterselva/ Antholz  CIRTV  Centre International de Radio et TÈlÈvision  CPP  Centre Principal de Presse  AUTRICHE  Stade de biathlon Anterselva di Mezzo/ Antholz Mittertal  BIATHLON  BRUNICO/BRUNECK  BOLZANO/BOZEN  Anterselva  VALDAORA/OLANG  Site olympique  Ville  Milan Autoroute  Ligne ferroviaire  DOBBIACO/TOBLACH Village olympique LIENZ  Lienz  ↖  CORTINA D'AMPEZZO  Gare"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "26  Les cartes des sites  ANTERSELVA/ANTHOLZ  Cortina d’Ampezzo  Fiames  CURLING BOBSLEIGH SKELETON LUGE  SKI ALPIN  Cortina Milan  Site olympique  Ville  Autoroute  Village olympique  VENISE MARCO POLO A…ROPORT PRINCIPAL, POINT DíENTR…E OFFICIEL  PREDAZZO ET TESERO  Gare  P‘LE CORTINA DíAMPEZZO  Val di Fiemme SAUT ¿ SKI COMBIN… NORDIQUE  Predazzo  ORA/AUER ET TRENTE  Tesero  Milan  SKI DE FOND COMBIN… NORDIQUE  Val di Fiemme  Site olympique  Autoroute  Ville  Ligne ferroviaire  Village olympique  Gare"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  27  Numéro 125  P‘LES CORTINA DíAMPEZZO ET VAL DI FIEMME  Valteline SUISSE  Livigno  SKI ACROBATIQUE SNOWBOARD  SKI ACROBATIQUE  Bormio  Valteline  SKI-ALPINISME Valdisotto TIRANO P‘LE MILAN  Vérone  C…R…MONIE DE CL‘TURE Bâties il y a presque 2 000 ans et utilisées au départ pour accueillir des combats de gladiateurs, les arènes de Vérone sont le troisième amphithéâtre le plus imposant d’Italie. Ce site recevra plus de 12 000 spectateurs qui viendront assister à la cérémonie de clôture des Jeux de Milano Cortina 2026.  Site olympique  Autoroute  SKI ALPIN  Ville  Milan Ligne ferroviaire  Village olympique  Gare"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 28-title\" style=\"top:112px;left:45px;\" src=\"/125/static/_content/28-caption-1.png\"/>\n        <img class=\"abs halfScale 28-title\" style=\"top:163px;left:45px;\" src=\"/125/static/_content/28-title-1.png\"/>\n        <img class=\"abs halfScale 28-sub\" style=\"top:293px;left:45px;\" src=\"/125/static/_content/28-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.staggerFromTo(cOf(\"28-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"28-sub\"), 0.9, {opacity:0, y:-10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.4)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg28Anim.stop();\n        }\n      ",
    "searchText": "28  Au-delà des anneaux  AU-DELÀ DES ANNEAUX  Déplacer des montagnes Les Jeux Olympiques d’hiver de Milano Cortina 2026 uniront les régions montagneuses de l’Italie comme jamais. Par Marco Bonarrigo  N  ous le savons depuis l’enfance : les Jeux Olympiques rassemblent tous ceux que l’histoire et la géographie séparent. Le podium rapproche les adversaires ; la compétition permet la rencontre de langues, de religions et d’ethnies différentes ; les cérémonies d’ouverture et de clôture réunissent des nations aux antagonismes séculaires. La magie opère tous les deux ans, en été et en hiver, et en 2026, notre planète déchirée par les conflits aura bien besoin de son lot de miracles. Ici, en Italie, un petit prodige s’est déjà produit : les Jeux Olympiques réuniront pour la première fois ces « montagnes italiennes » qui, par leur histoire et leurs traditions, sont plus différentes et souvent beaucoup plus éloignées les unes des autres que ne le laisse imaginer la courte distance qui les sépare. Les Jeux Olympiques d’hiver de 1956 ont été très brefs (11 jours de compétition) et concentrés sur une petite zone autour du centre historique de la merveilleuse Cortina d’Ampezzo. Ceux de 2006 ont duré 16 jours et se sont étendus à toute la province de Turin, mais sans en dépasser les frontières. Les Jeux de 2026 seront les premiers de l’histoire à impliquer l’ensemble des montagnes italiennes et à dépasser les 1 Cortina abrite certaines des pistes de ski alpin les plus célèbres d’Europe.  divergences issues de l’histoire moderne complexe du pays. Les montagnes de Cortina, l’un des points névralgiques des Jeux, le Val di Fiemme, royaume du ski nordique et du patinage, et Anterselva, capitale du biathlon, ne font partie du territoire italien que depuis un peu plus d’un siècle (elles ont été annexées en 1920, après la conférence de Paris). Imprégnées de traditions européennes, ces régions portent aussi les stigmates des batailles sanglantes de la Grande Guerre, dont elles ont été témoin en tant que territoires frontaliers. En somme, ceux qui connaissent bien nos Alpes savent parfaitement que le concept de « montagnes italiennes » est purement géographique : des espaces circonscrits aux frontières nationales. La réalité est plus complexe. Il suffit d’écouter les langues parlées dans les localités où se dérouleront les Jeux : dans ces montagnes, l’italien est toujours la deuxième ou troisième langue. À l’école, dans les habitations, dans les bâtiments publics et à la maison, on parle le ladin, le mochène, le cimbre, le romanche, le camunien (presque éteint), le badiot, le fodom, le tyrolien de Sappada, celui de Sauris ou de Timau. Ces langues et d’autres encore sont utilisées dans les journaux et à la télévision régionale et sont, à juste titre, source de fierté pour leurs locuteurs. Les langues des montagnes italiennes (et non les dialectes, qui sont encore à part) sont le merveilleux héritage d’une histoire millénaire et recèlent des traditions, des secrets, des règles et des cultures profondément ancrés. Les communautés locales les préservent et les transmettent jalousement. Entre les divers sites des Jeux Olympiques d’hiver de 2026, les rivalités administratives (statuts spéciaux,  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  Numéro 125  29  privilèges différents, écarts dans les investissements publics) n’ont jamais manqué, influençant également l’offre touristique sportive estivale et hivernale et créant parfois des disparités. Les Jeux Olympiques de Milano Cortina 2026 résultent d’un long et minutieux travail de médiation qui porte d’ores et déjà ses fruits : chacun des six sites olympiques italiens a été reconnu pour sa vocation sportive naturelle. Le Val di Fiemme, héritier de la tradition du ski nordique et du saut à ski, arrivée des pays scandinaves dans les années 1950 ; Cortina, berceau du bobsleigh, qui abrite aussi certaines des pistes de ski alpin les plus célèbres d’Europe ; Anterselva, de tous temps pôle d’excellence mondial du biathlon ; Bormio et Livigno, paradis du ski alpin. Et enfin Milan qui, avec ses salles multisports, offre un écrin idéal au patinage et au hockey sur glace, et ouvre les portes de San Siro, son temple du football, pour la cérémonie d’ouverture. Il est toujours difficile de mettre en place des projets sportifs de grande envergure tels que les Jeux Olympiques en Italie, en raison de la crainte (parfois légitime, compte tenu des événements passés) de ne pas être à la hauteur de la situation. Les Jeux de Milano Cortina 2026 veulent être les premiers Jeux d’hiver véritablement durables de la longue histoire olympique, les premiers à laisser un héritage permanent et écologique sur des territoires sensibles, et cette volonté est déjà un achèvement énorme en soi. ■  Diplômé en architecture et urbanisme de l’Université IUAV de Venise, Marco Bonarrigo est correspondant sport et grands reportages pour le Corriere della Sera, pour lequel il couvrira les Jeux Olympiques d’hiver de Milano Cortina 2026. Il a déjà suivi six éditions des Jeux, 20 Tours de France et des centaines d’autres événements sportifs."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 30-sub\" style=\"top:183px;left:266px;\" src=\"/125/static/_content/30-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.fromTo(cOf(\"30-sub\"), 0.9, {opacity:0, y:-10}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg30Anim.stop();\n        }\n      ",
    "searchText": "LES JEUX OLYMPIQUES REVIENNENT DANS LES ALPES ITALIENNES CET HIVER. RETOUR HISTORIQUE SUR UNE R…GION OŸ LA TRADITION DES SPORTS DíHIVER EST BIEN ANCR…E ET INTIMEMENT LI…E ¿ LíESSOR DU TOURISME. PAR SYLVAIN BOLT  Dès les années 1920-1930, Cortina est déjà un haut lieu du tourisme des sports hivernaux."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 31-title\" style=\"top:548px;left:39px;\" src=\"/125/static/_content/31-title-1.png\"/>\n        <img class=\"abs halfScale 31-title\" style=\"top:767px;left:71px;\" src=\"/125/static/_content/31-title-2.png\"/>\n        <img class=\"abs halfScale 31-title\" style=\"top:823px;left:333px;\" src=\"/125/static/_content/31-title-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.staggerFromTo(cOf(\"31-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg31Anim.stop();\n        }\n      ",
    "searchText": "Sylvain Bolt est journaliste à Tamedia (Suisse), spécialiste notamment de ski alpin et dans l’écriture d’articles qui abordent le sport sous un angle sociétal.  ravivent leur flamme pour les Jeux"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "32  Les Alpes italiennes et les sports d’hiver  D  u 6 au 22 février, l’Italie va raviver sa flamme olympique. Exactement 70 ans après une première hivernale des Jeux Olympiques à Cortina d’Ampezzo, la station des Dolomites est associée à Milan pour accueillir les quatrièmes Jeux sur le sol italien. Après un détour à Rome l’été 1960, puis un passage en hiver à Turin en 2006, les Jeux Olympiques d’hiver sont de retour dans les Alpes 20 ans plus tard – là où l’histoire olympique hivernale a vécu sa première édition, à Chamonix en 1924. Si les Jeux Olympiques de 1956 ont notamment permis à Cortina d’Ampezzo d’acquérir une renommée mondiale, son surnom de « capitale des sports d’hiver » remonte aux années 1930. Et il ne doit rien au hasard. « Dès les années 1920-1930, Cortina est déjà un haut lieu du tourisme des sports hivernaux, qui sont alors encore élitaires », souligne Nicola Sbetti, historien à l’Université de Bologne et spécialiste de l’histoire du sport international en relation avec la politique en Italie. « La station profite notamment de l’influence d’Alberto Bonacossa, un noble milanais amoureux de Cortina, qui va pousser pour l’organisation des Jeux de 1944 dans la région, annulés en raison de la Seconde Guerre mondiale. » La tentative de 1956 sera la bonne. Nichée au cœur du massif des Tofane, au sein des majestueuses Dolomites, la station  1  peut se targuer d’un statut de pionnière du développement des sports d’hiver dans le nord de l’Italie. À l’image de sa voisine française Chamonix ou de St-Moritz la Suissesse, hôte des deuxièmes Jeux Olympiques d’hiver en 1928, ces lieux misent sur leur côté glamour et accueillent des touristes fortunés dès la fin du XIXe siècle, d’abord en période estivale. Dans ce triptyque emblématique des Alpes (Cortina, Chamonix, St-Moritz), tourisme et essor des sports d’hiver vont former une paire gagnante dans les décennies suivantes. « Le ski alpin, le bobsleigh ou le curling sont alors pratiqués par des aristocrates et collent parfaitement à l’ADN et à l’atmosphère de ces  1 Des skieurs admirent la vue sur les majestueuses Dolomites autour de Cortina. 2 L’équipe suisse de bob à quatre en route vers l’or olympique en 1956. 3 De nombreuses remontées mécaniques ont été construites pour les Jeux de 1956."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  33  Numéro 125  2  stations chics », précise Grégory Quin, historien à l’Institut des Sciences du Sport de l’Université de Lausanne. « La piste de bobsleigh de St-Moritz, inaugurée le 1er janvier 1904, est la plus vieille au monde et possède une fonction exclusivement touristique, en particulier pour des hivernants britanniques amateurs de vitesse. » Le départ de l’infrastructure, lui, se trouve dans les jardins de l’hôtel Kulm, à deux pas du stade construit pour les Jeux de 1928. Des dizaines de pistes de bobsleigh sont dessinées autour des palaces de la station, comme à Cortina, où les hôtels en recherche constante d’innovation proposent aussi des pistes de curling et des patinoires à leurs clients. Dans un contexte de forte concurrence entre les régions, les hôteliers alpins vont ainsi devenir de véritables acteurs du développement des pratiques sportives, en organisant des compétitions de bobsleigh ou de ski. « Le bobsleigh, discipline historique olympique présente depuis la première  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "34  Les Alpes italiennes et les sports d’hiver  1  édition de Chamonix en 1924, incarne le processus d’hybridation entre les logiques touristiques et sportives qui façonnent les Jeux d’hiver depuis plus d’un siècle, analyse Grégory Quin. Les Jeux permettent de créer des pistes et d’institutionnaliser la pratique du bobsleigh, contribuant à l’essor de la discipline. » Le nord de l’Italie n’échappe pas au phénomène, incarné par « la perle des Dolomites » : Cortina organise très tôt les Championnats du monde de bobsleigh à deux (1937) puis à quatre (1939), dont la première édition en quatuor a lieu en 1930 à Caux (Suisse). Consciente des enjeux, la station italienne se positionne comme l’une des places fortes de la discipline dans les premières  1 La Française Josette Nevière participe à la descente féminine en 1956. 2 Les hôtels de la région ont proﬁté d’un boom touristique grâce aux Jeux Olympiques d’hiver de 1956. 3 En 2026, la descente féminine se déroulera sur la piste de l’Olimpia delle Tofane.  décennies d’existence de la compétition, car le serpentin glacé italien est aussi l’hôte des Mondiaux de 1950 et de 1954. Avant d’obtenir un statut olympique en 1956 et d’accueillir un total de neuf Championnats du monde (huit pour le bob à deux) entre 1937 et 1989. Après les premiers Championnats du monde de ski alpin qui sont organisés à Mürren (Suisse) en 1931, Cortina accueille la deuxième édition l’hiver suivant, ce qui lui permet également de s’affirmer comme un lieu emblématique de la discipline qui connaîtra un essor fulgurant dans les décennies suivantes. Dix ans plus tard, en pleine Seconde Guerre mondiale, la compétition se tient à nouveau à Cortina, sans obtenir de statut officiel.  Le nord de l’Italie, propice à l’essor du tourisme alpin Ces choix stratégiques braquent les projecteurs sur la région du nord de l’Italie, qui profite aussi d’un coup de pouce géographique. « Aucun pays n’a une part de la chaîne des Alpes aussi  longue que l’Italie sur son territoire(», ajoute Grégory Quin, qui est aussi directeur du Centre interdisciplinaire de recherche sur la montagne de l’Université de Lausanne. «(Dans cette partie du pays qui est plus riche, davantage de monde se trouve à proximité des Alpes et sera capable de consommer ce que ces lieux proposent, ce qui va faciliter l’essor du tourisme. » Le développement des sports d’hiver est favorisé par les structures hôtelières, qui ont les capacités d’hébergement nécessaires pour accueillir de grandes manifestations sportives. Un contexte qui renforce le poids des hôteliers. « Les hôteliers siègent au sein des conseils d’administration des remontées mécaniques ou ceux des lignes de chemins de fer, précise Grégory Quin. La plupart du temps, ils exercent également des fonctions politiques. » Cette logique explique le lien intime entre l’évolution des sports d’hiver, du tourisme et des transports. Pour les compagnies de transport, l’intérêt est de profiter de l’afflux de nouveaux touristes étrangers attirés par les infrastructures"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  35  Numéro 125  2  2  3  3  et les manifestations, mais aussi de servir de remonte-pente aux lugeurs et aux skieurs. Le départ de la piste de bobsleigh de Chamonix, où se tient la « Semaine internationale des sports d’hiver » de 1924, est ainsi localisé à l’arrivée du premier tronçon d’un funiculaire. Afin de pouvoir accueillir des visiteurs de Paris, la ligne de chemin de fer est déneigée sur plusieurs kilomètres : cette opération ouvre la voie à une liaison régulière entre Paris et Chamonix, qui sera dès lors organisée chaque hiver. Ces premiers Jeux Olympiques d’hiver, censés faire rayonner la région en dévoilant son potentiel touristique à travers ses pratiques sportives, remplissent parfaitement leur mission. « Pour les Jeux Olympiques de 1956, une route va par exemple être construite en direction de Cortina, ainsi que de nombreuses remontées mécaniques, qui vont se multiplier après les Jeux », illustre Nicola Sbetti. St-Moritz va quant à elle profiter d’une ligne de train depuis Coire (Suisse) pour vivre un boom touristique. «(Les taux de croissance des lieux d’accueil des sports d’hiver sont direchtement corrélés avec la capacité de s’y rendre en train, résume Grégory Quin. Il s’agit d’un système touristique, qui comprend l’hôtelier, le chemin(de fer ou la route, puis la remontée mécanique. »"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "36  Les Alpes italiennes et les sports d’hiver  Une tradition italienne des sports d’hiver bien ancrée Les Jeux Olympiques d’hiver de Cortina 1956 marquent un tournant symbolique dans l’histoire sportive italienne. « Après avoir mangé son pain noir juste après la Seconde Guerre mondiale, l’Italie est le premier pays des vaincus à relancer son image grâce aux Jeux Olympiques, analyse Nicola Sbetti. À travers cet événement, puis aux Jeux d’été de Rome en 1960, le pays veut démontrer qu’il est capable d’être un bon organisateur. Cortina 1956 prouve l’efficience italienne dans l’organisation d’une compétition majeure internationale. Malgré sa réputation d’être en retard dans les préparatifs, l’Italie réussit finalement toujours à livrer un événement réussi, à l’image des Jeux de Turin 2006 et ceux de Milano Cortina prochainement. » Le timing, lui, tombe pile à l’heure pour l’Italie, prête au meilleur des moments pour saisir l’aubaine olympique. « Cortina 1956 profite de ce que les historiens de l’économie appelleraient un “take-off”, période de plein boom, marquée notamment par les Trente Glorieuses, souligne Grégory Quin. Toute la région profite de l’or blanc, comme si les  planètes étaient parfaitement alignées. » Le contexte favorise la démocratisation des pratiques sportives hivernales, qui ne sont plus uniquement réservées à une élite. Le développement d’un tourisme de masse accompagne ce processus. Cortina, qui surfe sur la beauté de toute une région magnifiée par les Jeux Olympiques, se forge une réputation qui va entrer dans l’imaginaire collectif dans les années 1980, grâce notamment au cinéma. Le passage de James Bond dans Rien que pour vos yeux ou le film Vacances de Noël érigent la station en emblème du tourisme de luxe en montagne. Hôte des Jeux Olympiques de 2026, la région du nord de l’Italie située entre Milan et Cortina peut se vanter d’une riche tradition des sports d’hiver. Les premières compétitions de bobsleigh et de ski alpin ont posé les jalons de plusieurs autres éditions dans ce périmètre, à l’image de Val Gardena ou de Bormio qui vont ensuite organiser des Mondiaux de ski alpin. L’organisation des Jeux Olympiques de Cortina 1956 a consolidé des bases solides en termes de crédibilité, profitant à tout le territoire alpin concerné qui va ainsi capitaliser sur son savoir-faire en termes de sports d’hiver.  1  Un véritable effet boule de neige va s’opérer. « En ski alpin, notamment, le nord de l’Italie va devenir une référence, explique Nicola Sbetti. Des stations comme Bormio, Alta Badia, Val Gardena ou Sestrières vont commencer à concurrencer Cortina, grâce notamment à l’avènement de la Coupe du monde de ski alpin qui va les médiatiser dans le monde entier. » Lancé par le magazine L’Équipe, le fameux « cirque blanc » comptera notamment comme étapes Madonna di Campliglio et Sestrières, aux côtés de Wengen ou de Kitzbühel, lors de son premier hiver de compétition en janvier 1967. Les retransmissions télévisées en direct vont contribuer à populariser le ski alpin, mais aussi les régions concernées par ces épreuves. Ce savoir-faire italien reconnu a ainsi permis à la région de se placer sur la carte mondiale des sports d’hiver ces dernières décennies ; et à ses athlètes de faire figurer leur pays parmi les meilleures nations du monde au tableau des médailles dans des disciplines bien ancrées et très populaires aux Jeux Olympiques, comme le ski alpin et le bobsleigh. « Cortina, une station qui possède l’un des ski-clubs les plus anciens au monde, a accueilli plus de 100 courses de Coupe du monde de ski alpin entre les hommes et les femmes. Bormio et sa Stelvio près de cinquante courses », détaille Alberto Ghezze, directeur des compétitions sportives au comité d’organisation de Milano Cortina 2026. « Anterselva, qui accueillera les épreuves de biathlon cet hiver, est devenue une étape de référence en Coupe du monde, organisant aussi plusieurs éditions des Mondiaux. Quant au Val di Fiemme, hôte des épreuves de fond, de saut à ski et de combiné nordique en février prochain, il accueille chaque année le prestigieux Tour de Ski de ski de fond et a organisé des éditions des Mondiaux de ski nordique. Notre expertise locale est historiquement très ancrée dans ces régions. »  Les Alpes au cœur des Jeux ces prochaines décennies Le riche passé italien en matière de sports hivernaux a notamment été mis en lumière par les Jeux Olympiques de Turin 2006. Mais aussi par ces nombreuses compétitions internationales dans la région, auxquelles on  1 Anterselva est devenue l’une des étapes de référence de la Coupe du monde de biathlon et accueillera les épreuves olympiques de ce sport cet hiver."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 38-title\" style=\"top:99px;left:294px;\" src=\"/125/static/_content/38-title-1.png\"/>\n        <img class=\"abs halfScale 38-title\" style=\"top:204px;left:300px;\" src=\"/125/static/_content/38-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.staggerFromTo(cOf(\"38-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg38Anim.stop();\n        }\n      ",
    "searchText": "38  Les Alpes italiennes et les sports d’hiver  peut aussi rajouter Cortina, hôte des Mondiaux de curling (2010) et de ski alpin (2021), permettant à chaque fois de construire de nouvelles infrastructures ou de les rénover. À l’aube des Jeux de 2026, la station des Dolomites est plus attractive que jamais. « Le tissu économique est en plein renouveau à Cortina : nouveaux hôtels, nouvelles remontées mécaniques, meilleures connexions entre les domaines skiables, nouveaux équipements liés aux futurs Jeux Olympiques », déroule Nicola Sbetti. C’est la démonstration que de grands événements peuvent représenter de réels changements pour la communauté locale et dynamiser toute une région. Une modernité qui trouve ses racines dans la tradition, illustrée par la mythique piste de l’Olimpia delle Tofane, à Cortina, qui sert de trait d’union entre le passé (descente olympique masculine en 1956) et le présent (descente olympique féminine en 2026). « Cette descente est considérée comme l’une des plus attractives du circuit féminin, alors que Bormio, qui accueillera la descente olympique masculine, est l’une des plus redoutées de la Coupe du monde masculine, se réjouit Alberto Ghezze. Ces tracés mythiques vont consacrer de grands champions et championnes en février prochain !(» Les anneaux olympiques sont prêts à scintiller entre Milan et Cortina, pour illuminer une région du nord de l’Italie qui partage un fort héritage alpin autour des sports d’hiver. Les pionnières « olympiques » des Alpes (Chamonix en 1924, St-Moritz en 1928 et 1948, et Cortina en 1956) vont retrouver leurs habits de lumière dans la prochaine décennie : Milano Cortina (2026), puis les Alpes françaises (2030) et une candidature suisse pour 2038. Des choix qui font écho à l’Agenda olympique. « La part des Alpes dans les lieux probables des futurs Jeux Olympiques va croître, pour des raisons climatiques et topographiques notamment », estime Grégory Quin. Voici les Jeux Olympiques de retour dans leur berceau hivernal au meilleur des moments. ■  1 Le stade olympique de glace a été le théâtre des épreuves de patinage artistique et de hockey sur glace en 1956. 2 Exactement 70 ans plus tard, il accueillera les épreuves olympiques de curling.  La patinoire de Cortina Entre tradition et modernitÈ  1  Héritage matériel des premiers Jeux Olympiques qui ont eu lieu en Italie, le stade olympique de glace a été le théâtre des épreuves de patinage artistique et de hockey sur glace aux Jeux Olympiques de Cortina d’Ampezzo en 1956, mais aussi des cérémonies d’ouverture et de fermeture. À l’époque, la patinoire se distingue par son architecture en béton, matériau de construction par excellence  des Trente Glorieuses. Rénové, le stade de glace de Cortina sera entièrement dédié aux tournois de curling aux Jeux de 2026. «(La discipline n’était pas olympique en 1956 et c’est à Cortina d’Ampezzo en Italie qu’elle l’est devenue », rappelle Alberto Ghezze, directeur des compétitions sportives au comité d’organisation de Milano Cortina 2026. La patinoire présente aujourd’hui un  2  mélange fascinant entre un design moderne, tout en conservant des traces du passé, dont sa tribune en bois d’origine. Comme un témoin d’une longue et riche tradition."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "©2021: Marco Bertorello / Getty Images /All rights reserved  Always with you for whatever’s ahead of you Visa, proud partner of the Olympic and Paralympic Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        \n        <img class=\"abs halfScale 40-title-2\" style=\"top:705px;left:169px;\" src=\"/125/static/_content/40-title-2.png\"/>\n        <img class=\"abs halfScale 40-title-1\" style=\"top:617px;left:40px;\" src=\"/125/static/_content/40-title-1.png\"/>\n        <img class=\"abs halfScale 40-sub\" style=\"top:803px;left:169px;\" src=\"/125/static/_content/40-sub-1.png\"/>\n\n        <a href=\"https://www.olympics.com/en/films/watch/into-the-unknown?uxreference=playlist\" target=\"_blank\"><img class=\"halfScaleC halfpulse animatedpulse pointer z-index-set\" src=\"/125/static/_content/black-play.png\" style=\"top:795px;left:95px;\" /></a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.fromTo(cOf(\"40-title-1\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"40-title-2\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"40-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.5)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg40Anim.stop();\n        }\n      ",
    "searchText": "Les champions  DES CIMES  FORT DE SES RACINES ALPINES ET PORT… PAR UN ENGOUEMENT GRANDISSANT CES DERNI»RES ANN…ES, LE SKI-ALPINISME VA FAIRE UNE ENTR…E SPECTACULAIRE AUX JEUX OLYMPIQUES DíHIVER DE MILANO CORTINA 2026. PAR BRIAN PINELLI"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Trente-six athlètes s’affronteront pour les toutes premières médailles olympiques en ski-alpinisme."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympics.com/fr/milano-cortina-2026/sports/ski-alpinisme\" target=\"_blank\" class=\"addContentLink\" style=\"top:108px; left:86px; width:61px; height:14px;\"></a>  \n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "42  Les champions des cimes  L  e ski-alpinisme vit une saison historique. La tension était palpable lorsque l’élite mondiale s’est réunie en décembre au Solitude Mountain Resort dans l’Utah (États-Unis), car les premières manches de Coupe du monde de l’ISMF (Fédération internationale de ski-alpinisme) faisaient office de dernière épreuve de qualification pour les Jeux Olympiques d’hiver de Milano Cortina 2026. À peine deux mois plus tard, le skialpinisme vivra son inauguration au sein du programme olympique. Athlète belge de 28 ans résidant en Suisse, Maximilien Drion du Chapois explique l’impact de l’intégration aux Jeux Olympiques de la version compétitive du ski de randonnée. « Nous bénéficions de plus d’exposition et de soutien de la part des Fédérations et des  Comités Nationaux Olympiques : c’est passionnant de faire partie de la grande famille olympique, confie-t-il. À titre personnel, cette reconnaissance me permet maintenant de vivre de mon sport. » L’ajout du ski-alpinisme au programme de Milano Cortina 2026 a été approuvée en juillet 2021 par la commission exécutive du CIO. Alors que ce sport se prépare pour ses débuts olympiques, nombreux sont ceux qui s’enthousiasment de sa forte croissance, à l’image de Griffin Briley, un athlète de 20 ans originaire de Park City, Utah (États-Unis) et déjà quadruple champion du monde junior. « C’est vraiment cool de voir autant de monde à la montagne s’éclater avec le ski-alpinisme, pour le plaisir et maintenant pour la compétition, s’enthousiasme-t-il. Depuis l’annonce de son entrée aux Jeux, on  observe une spécialisation accrue et un intérêt grandissant pour les nouvelles disciplines, ce qui a fait nettement monter le niveau. » La compétition olympique rassemblera 36 athlètes (18 hommes et 18 femmes) qui s’affronteront pour les premières médailles olympiques dans trois épreuves : les sprints masculin et féminin, ainsi qu’un relais mixte par équipes. Les courses se dérouleront les 19 et 21 février 2026 dans la partie inférieure de la piste du Stelvio, à Bormio (Haute-Valteline). Composées de manches d’élimination et d’une finale à six athlètes, les épreuves de sprint s’annoncent comme une version passionnante et condensée des épreuves traditionnelles de ski-alpinisme, plus longues et exigeantes. Les athlètes s’affronteront au coude-à-coude lors de trois phases distinctes : une montée à travers des obstacles avec des  1  ´ C’EST PASSIONNANT DE FAIRE PARTIE DE LA GRANDE FAMILLE OLYMPIQUE. ª Maximilien Drion du Chapois"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  43  Numéro 125  peaux fixées à leurs skis ; une ascension avec les skis accrochés sur le dos ; et enfin, une descente jusqu’à la ligne d’arrivée avec des fixations spéciales. Les sprints de ski-alpinisme sont très différents des épreuves plus traditionnelles de ce sport. Toutefois, ils mélangent tactique, vitesse et explosivité, avec des courses qui durent généralement un peu plus de 3 minutes, pour un dénivelé positif d’environ 70 mètres. « C’est totalement différent : quand on parle de ski-alpinisme, on pense généralement à de longues ascensions vers le sommet puis à redescendre dans la poudreuse ; à franchir des crêtes et à relier des vallées et des villages, explique Maximilien Drion du Chapois. On ne pense pas à une montée de deux minutes avant d’enchaîner immédiatement sur une descente. » « Mais c’est une épreuve fun et passionnante. D’ailleurs, ces cinq dernières années, on a vu de plus en plus d’athlètes se spécialiser dans les sprints. » Griffin Briley partage sa tactique lors des sprints : « Tu dois être agressif, être le premier à bouger quand c’est le bon moment », révèle la star montante des États-Unis. « Mais la moindre erreur est quasiment synonyme d’élimination. » Le skieur suisse de 22 ans, Jon Kistler, ajoute avec entrain : « On ne s’ennuie jamais, ça bouge du début à la fin. » Une épreuve test olympique s’est déroulée à Bormio les 22 et 23 février 2025. Les sprints individuels sur le parcours de 610 m ont été remportés par la skieuse française Emily Harrop et le skieur espagnol Oriol Cardona Coll. Ce dernier a ensuite fait équipe avec sa compatriote Ana Alonso Rodriguez pour s’imposer face à la France dans le relais mixte par équipes. Organisée sur deux jours, cette compétition a servi de précieuse mission de reconnaissance pour les aspirants olympiens, tout en permettant aux organisateurs d’affiner les derniers détails. « Le sprint est très exigeant sur le plan physique, avec des virages inclinés, et il n’est pas facile de dépasser ses concurrents en descente », explique Emilie Harrop, qui a remporté les quatre derniers Globes de cristal du général et du sprint. « L’ambiance était bonne et c’est une piste très sympa : je pense que les Jeux Olympiques seront une réussite. » Arrivé deuxième derrière Oriol Cardona Coll dans le sprint masculin, Jon Kistler retient toutefois un moment riche d’enseignements dans une discipline où tout peut changer en un  2  3  4  clin d’œil. « J’avais une bonne avance sur le reste du groupe jusqu’à ce qu’ils commencent à me talonner, surtout Oriol, décrit l’athlète suisse. Il était tellement fort sur la fin… La victoire m’a échappé de peu. Mais c’était sympa d’acquérir de l’expérience sur la piste olympique. » Les épreuves classiques de ski-alpinisme puisent leurs racines dans les Alpes, qu’il s’agisse du Trophée Mezzalama en Italie (dont la première édition s’est déroulée en 1933) ou de la Patrouille des Glaciers en Suisse, qui existe depuis 1943. Elles symbolisent les  1 Le ski-alpinisme faisait partie du programme des JOJ de Lausanne 2020. 2 Maximilien Drion du Chapois lors des épreuves tests. 3 Oriol Cordona Coll et Ana Alonso Rodriguez espèrent être en lice pour une médaille dans le relais mixte par équipes. 4 La partie inférieure de la piste du Stelvio à Bormio accueillera les trois épreuves de ski-alpinisme."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "44  Les champions des cimes  origines de ce sport, né dans le sillage du ski récréatif, lorsque de courageux alpinistes escaladaient des pics enneigés et traversaient des cols avec les moyens du bord, bien avant l’arrivée des remontées mécaniques. Compte tenu de ses origines, le sport a longtemps été dominé par des athlètes provenant d’Italie, de France et de Suisse, mais la popularité du ski-alpinisme a transcendé les frontières, car il offre une aventure en plein air et une pratique physique en immersion dans la nature. Il bénéficie aussi de la croissance du ski de randonnée récréatif, en plus de son nouveau statut de sport olympique. L’ISMF compte actuellement 55 fédérations nationales. « Ce sport a un gros potentiel d’évolution, souligne Griffin Briley. Il y a d’autres disciplines au-delà de celles qui seront aux Jeux. » Présidente de l’ISMF, Regula Meier rappelle que sa priorité est de développer cette pratique hors de son berceau d’origine : « Les gens pensent que notre sport se cantonne à l’Europe, mais l’universalité est primordiale. Il était important que nous débutions la saison sur un autre continent, en Utah, et nous avons également organisé des épreuves en Asie. » « Nous devons devenir un sport mondial et continuer à nous développer. Au moment de l’annonce de notre intégration dans le programme olympique, nous comptions 38 membres ; aujourd’hui, nous en avons 55. [...] Milano Cortina est une étape, mais nous travaillons déjà activement pour 2030 et 2034. » Les 36 athlètes qualifiés pour les Jeux donneront tout sur la piste du Stelvio. Avec une bonne exécution, une tactique intelligente et un brin de chance, ils entreront dans l’histoire comme les premiers athlètes à décrocher une médaille olympique dans ce sport. C’est ce qu’espère Maximilien Drion du Chapois, qui vise la toute première médaille olympique belge, toutes disciplines de ski confondues : « C’est un grand honneur de représenter mon pays dans les sports d’hiver, de rivaliser avec les grandes nations et parfois de les battre, explique l’athlète. Remporter une médaille en ski-alpinisme, ça serait la culmination d’années de travail. Ce serait aussi la preuve que peu importe d’où vous venez, il est possible d’atteindre ses objectifs à force de travail et de confiance en soi. » ■  1 La française Emily Harrop visera deux médailles d’or à Milano Cortina 2026.  1  Emily Harrop  FIGURE DE PROUE DU SKI-ALPINISME AUX JEUX  L  ’athlète française Emily Harrop a vécu une saison 2024/25 quasi parfaite : elle a remporté les sept épreuves de sprint en Coupe du monde de l’ISMF pour s’adjuger son quatrième titre consécutif au classement général et en sprint. « Mon objectif, c’était surtout de tenter de nouvelles choses et de progresser à chaque épreuve. Mais au vu des résultats, j’ai réussi une saison presque parfaite », dit Emily Harrop, originaire du petit village de Sainte-Foy, dans la vallée de la Tarentaise. « Il m’a seulement manqué une victoire aux Championnats du monde, mais c’est ce qu’il faut pour se motiver pour la suite. » À 28 ans, l’athlète a conclu une saison exceptionnelle par une victoire au Trophée Mezzalama, la mythique course italienne de 45 km, en duo avec Axelle Gachet-Mollaret. La paire tricolore a mené la course de bout en bout, en montée comme en descente.  Ancienne skieuse alpine, Emily Harrop fera ﬁgure de favorite aux Jeux dans l’épreuve féminine de sprint comme en relais mixte, où elle pourrait faire équipe avec son compatriote Thibault Anselmet, lui aussi champion du monde. La prestation impressionnante de la Française au Mezzalama démontre sa polyvalence et son endurance, deux atouts majeurs dans une longue journée composée de séries éliminatoires et d’une ﬁnale. « J’adore les courses classiques avec des dénivelés positifs de plus de 4 000 m : c’est tellement enivrant ! Mais mon entraînement se concentre sur le sprint et le relais pour préparer les Jeux, explique la championne. Mon objectif est clairement de viser deux médailles d’or [aux Jeux]. Ça serait fabuleux et on a la capacité d’y arriver. Visez les étoiles et au pire, vous atterrirez sur la Lune. »"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Bold innovations for  peak performance Through our technology integration services we’re helping the IOC keep innovation, impact, and legacy at its heart."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "LONDRES 1948 Les Jeux Olympiques de Londres 1948 ont marqué le début de la commercialisation des droits de diffusion, posant les fondations des accords sur les droits médias actuels et assurant une source de ﬁnancement essentielle au Mouvement olympique."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 47-title\" style=\"top:94px;left:313px;\" src=\"/125/static/_content/47-title-1.png\"/>\n        <img class=\"abs halfScale 47-title\" style=\"top:164px;left:363px;\" src=\"/125/static/_content/47-title-2.png\"/>\n        <img class=\"abs halfScale 47-sub\" style=\"top:250px;left:353px;\" src=\"/125/static/_content/47-sub-1.png\"/>\n        <img class=\"abs halfScale 47-corner-1\" style=\"top:78px;left:272px;\" src=\"/125/static/_content/47-corner-1.png\"/>\n        <img class=\"abs halfScale 47-corner-2\" style=\"top:358px;left:611px;\" src=\"/125/static/_content/47-corner-2.png\"/>\n\n        <a href=\"https://www.olympics.com/cio/milano-cortina-2026-diffusion\" target=\"_blank\" class=\"addContentLink\" style=\"top:344px; left:353px; width:212px; height:14px;\"></a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.staggerFromTo(cOf(\"47-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"47-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n          .fromTo(cOf(\"47-corner-1\"), 0.7, {opacity:0, y:-30, x:-30}, {opacity: 1, y: 0, x:0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.9)\n          .fromTo(cOf(\"47-corner-2\"), 0.7, {opacity:0, y:30, x:30}, {opacity: 1, y: 0, x:0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.9)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg47Anim.stop();\n        }\n      ",
    "searchText": "Sur le  VIF  DEPUIS NEUF DÉCENNIES, LES JEUX OLYMPIQUES SONT À LA POINTE DE L’INNOVATION EN MATIÈRE DE DIFFUSION. À L’AUBE DE L’ÉDITION DE MILANO CORTINA 2026, LAQUELLE S’INSCRIT DANS CETTE CONTINUITÉ, RETOUR EN IMAGES SUR 90 ANS DE DIFFUSION OLYMPIQUE."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 48-title\" style=\"top:123px;left:52px;\" src=\"/125/static/_content/48-title-1.png\"/>\n        <img class=\"abs halfScale 48-title\" style=\"top:194px;left:93px;\" src=\"/125/static/_content/48-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg48Anim.stop();\n        }\n      ",
    "searchText": "48  À travers l’objectif  Un noveau CHAPITRE D  es rediffusions permises par l’IA aux caméras montées sur drones en passant par une narration digne du grand écran, les services olympiques de radio-télévision (OBS) promettent une expérience sans précédent grâce à une couverture plus immersive et plus riche en données pour les Jeux Olympiques d’hiver de Milano Cortina 2026. Elle offrira aux spectateurs du monde entier une plongée au cœur du parcours des athlètes. « Chez OBS, nous faisons le choix de l’innovation avec conviction », explique Yiannis Exarchos, directeur général d’OBS. « À chaque édition des Jeux, nous repoussons les frontières technologiques pour enrichir l’expérience des spectateurs avec un but précis : mettre en lumière le parcours des plus grands athlètes du monde à travers une narration captivante et immersive. La technologie est un moyen, non le but ultime. Chaque innovation que nous adoptons est motivée par l’objectif d’enrichir l’expérience olympique offerte au public à l’échelle mondiale. » L’une des caractéristiques majeures envisagées pour Milano Cortina 2026 réside dans le recours accru à l’IA pour optimiser la couverture en direct et la narration. Qu’il s’agisse de rediffusions plus intelligentes qui décomposent les mouvements des athlètes en séquences claires ou de graphiques à l’écran qui facilitent la comparaison des performances en temps réel, ces outils offriront un aperçu sans précédent de la stratégie, de la technique et de l’exécution. Au curling, par exemple, l’IA tracera avec précision la trajectoire des pierres, aidant ainsi les spectateurs à comprendre les tactiques en jeu comme jamais auparavant. Une couverture plus importante par drone ajoutera également de nouvelles perspectives dynamiques à de nombreux événements, tandis que les caméras cinématographiques aideront à transmettre l’émotion et l’intensité dramatique des moments clés dans tous les sports. « Pour Milano Cortina 2026, notre approche ne se limite pas à une seule innovation, mais consiste à intégrer et déployer à grande échelle un ensemble de nouvelles technologies au niveau olympique, précise Yiannis Exarchos. Cette démarche nous permettra de proposer la diffusion des Jeux Olympiques d’hiver la plus immersive et la plus dynamique à ce jour. »"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  49  Numéro 125  MiLANO CORTiNA 2026 La couverture assurée par OBS offrira un degré d’immersion sans précédent grâce à des rediffusions alimentées par l’IA, des prises de vue par drones et des visuels cinématographiques qui promettent une expérience et une émotion inédites. Ces innovations renforceront la qualité de la narration et rapprocheront les passionnés de sport et les athlètes, entretenant ainsi la longue tradition des Jeux à repousser les limites de la technologie de diffusion."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 50-title\" style=\"top:116px;left:37px;\" src=\"/125/static/_content/50-title-1.png\"/>\n        <img class=\"abs halfScale 50-title\" style=\"top:198px;left:112px;\" src=\"/125/static/_content/50-title-2.png\"/>\n\n        <a href=\"https://www.obs.tv/home\" target=\"_blank\" class=\"addContentLink\" style=\"top:529px; left:67px; width:24px; height:14px;\"></a>  \n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim.staggerFromTo(cOf(\"50-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg50Anim.stop();\n        }\n      ",
    "searchText": "50  À travers l’objectif  Neuf décennies D’INNOVATION D  epuis 90 ans, les Jeux Olympiques sont le moteur de l’innovation dans le domaine de la diffusion sportive. Des premières retransmissions télévisées nationales aux diffusions mondiales multiplateformes optimisées par l’IA, chaque édition a été marquée par des étapes technologiques qui ont transformé la manière dont le monde vit l’expérience sportive olympique. Selon Isidoro Moreno, responsable de l’ingénierie chez OBS : « Plutôt qu’une invention en particulier, c’est la superposition continue d’innovations au fil du temps qui a transformé l’expérience de la diffusion des Jeux. » Des avancées majeures comme l’introduction de la transmission par satellite à Tokyo 1964, de la couleur et du ralenti à Mexico 1968, ou encore de la haute définition à Beijing 2008, ont chacune repoussé les limites en matière de diffusion. « Chaque édition des Jeux a introduit des innovations qui servent de tremplin dans notre parcours continu pour repousser les limites de la diffusion olympique et à rapprocher les passionnés de sport des athlètes, de leurs émotions et de leur histoire », ajoute Yiannis Exarchos."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  51  Numéro 125  BERLiN 1936 Les Jeux Olympiques de Berlin 1936 ont marqué la naissance de la diffusion olympique, grâce à la toute première transmission d’images télévisées en direct. Malgré une diffusion restreinte à quelques lieux publics à Berlin et Potsdam, cette initiative a marqué les débuts prometteurs du sport en direct à la télévision.  MEXiCO 1968 À Mexico 1968, les Jeux ont révolutionné la diffusion pour les téléspectateurs grâce à deux avancées spectaculaires : l’arrivée de la couleur et celle du ralenti en direct. Pour la première fois, les téléspectateurs du monde entier ont pu vivre toute l’intensité des Jeux Olympiques dans des couleurs éclatantes, pour une expérience plus riche, tandis que l’utilisation du ralenti en direct a permis une meilleure compréhension et appréciation des performances athlétiques."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "52  À travers l’objectif  MONTRÉAL 1976 Ces Jeux ont inauguré une nouvelle approche de la narration visuelle, l’introduction de caméras portables remplaçant de nombreuses installations ﬁxes, permettant ainsi de mieux capturer la dimension humaine de l’événement. Ces caméras ont permis aux équipes de se rapprocher de l’action, de réaliser des gros plans au plus près des athlètes et de transmettre avec une intensité inédite la tension et l’émotion des Jeux.  SARAJEVO 1984 L’édition d’hiver de Sarajevo 1984 a illustré les progrès continus en matière de coordination de la diffusion, le Centre International de Radio et Télévision (CIRTV), servant de plaque tournante pour la gestion des signaux en direct provenant de sites multiples. Doté d’une salle de contrôle dédiée à la transmission, d’installations d’enregistrement vidéo et de studios de production, le centre témoignait de l’évolution de la diffusion olympique vers une plus grande sophistication technique."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  53  Numéro 125  BEIJING 2008 Premiers Jeux Olympiques entièrement produits en haute déﬁnition, Beijing 2008 ont établi une nouvelle norme en matière de qualité d’image pour l’ensemble des disciplines sportives. Cette édition a aussi été la première à être diffusée par OBS en tant que diffuseur hôte permanent, ce qui a permis d’améliorer la cohérence et la planiﬁcation à long terme de la couverture des Jeux."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "54  À travers l’objectif  TOKYO 2020 Cette édition a marqué un tournant dans l’évolution de la diffusion olympique. Entièrement produits en mode natif ultra-haute déﬁnition avec une plage dynamique élevée (UHD HDR), ces Jeux ont offert une qualité d’image inégalée. Ils ont aussi marqué la première intégration complète d’une infrastructure cloud à la production en direct, permettant aux équipes d’accéder aux contenus à distance via OBS Cloud, réduisant l’empreinte environnementale et optimisant la ﬂexibilité et l’efficacité opérationnelle. Tokyo 2020 ont également été marqués par l’essor des plateformes numériques, avec une couverture étendue sur les services de streaming et les réseaux sociaux, inaugurant une nouvelle ère d’interaction du public avec les Jeux."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 56-title\" style=\"top:169px;left:46px;\" src=\"/125/static/_content/56-title-1.png\"/>\n        <img class=\"abs halfScale 56-title\" style=\"top:223px;left:49px;\" src=\"/125/static/_content/56-title-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg56Anim = new TimelineMax();\n          pg56Anim.staggerFromTo(cOf(\"56-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg56Anim.stop();\n        }\n      ",
    "searchText": "56  À travers l’objectif  DES BASES pour l’avenir S  i chaque édition des Jeux Olympiques a apporté son lot d’innovations techniques majeures, la création d’OBS en 2001 représente sans doute l’avancée la plus déterminante dans la diffusion des Jeux Olympiques. Elle permet de disposer d’une structure pérenne qui favorise une planification à long terme, une cohérence et une innovation constante d’une édition à l’autre. « Avant la création d’OBS en tant que diffuseur hôte permanent, à chaque édition des Jeux Olympiques, il fallait constituer une nouvelle équipe de diffuseurs hôtes à partir de zéro, se souvient Isidoro Moreno. La création d’OBS a changé la donne. Grâce à une équipe dédiée et permanente, nous avons pu développer une expertise approfondie et mettre au point des procédures cohérentes reconduites d’une édition à l’autre. Cette continuité nous permet de planifier à long terme, d’investir dans des technologies évolutives et d’affiner chaque aspect de la production. » De la production haute définition à Beijing 2008, de l’UHD HDR et des flux de travail basés sur le cloud à Tokyo 2020, ou des outils de narration alimentés par l’IA et des opérations à  distance déployés à Paris 2024 et au-delà, ce modèle a favorisé de nombreuses avancées. En plus de faciliter l’innovation technique d’une édition à l’autre, le modèle reposant sur un diffuseur hôte permanent a permis à OBS d’ancrer la durabilité dans sa stratégie à long terme, en repensant ses opérations afin de réduire l’impact environnemental en continuant à fournir une couverture de classe mondiale. « L’innovation aux Jeux Olympiques va bien au-delà de la technologie – elle consiste avant tout à rapprocher les fans de l’émotion et de l’esprit des Jeux tout en renforçant la durabilité et l’efficacité opérationnelle, poursuit Yiannis Exarchos. La durabilité est un axe stratégique pour OBS depuis Beijing 2008, orientant la refonte de nos opérations afin de nous aider à faire plus avec moins, tout en réduisant notre empreinte environnementale sans compromettre la qualité de la couverture. » À Paris 2024, OBS a diminué de 10 % son empreinte au niveau du CIRTV, cœur névralgique des opérations de diffusion des Jeux. La consommation énergétique du site a été réduite de près d’un tiers par rapport à Tokyo 2020, tandis que la moitié du câblage a été réutilisée ou recyclée. D’ici les Jeux de LA28, la taille du CIRTV devrait être réduite de 38 % comparativement à Rio 2016."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  57  Numéro 125  PARIS 2024 Paris 2024 a perpétué la tradition d’innovation d’OBS en améliorant l’expérience des spectateurs grâce à une narration immersive et à une technologie de pointe. Les outils alimentés par l’IA ont permis de suivre les mouvements, d’afficher les données en temps réel et d’analyser visuellement les performances des athlètes en une fraction de seconde, offrant aux spectateurs une immersion inédite, enrichie par la création automatique de séquences de moments forts. La production cloud a également permis de réduire l’empreinte carbone de la diffusion tout en optimisant l’efficacité opérationnelle. L’utilisation d’objectifs cinématographiques, les récits des coulisses et les « Moments de l’athlète » empreints d’émotion après la compétition ont contribué à rapprocher les fans de l’action d’une manière inédite.  En parallèle des avancées technologiques, OBS poursuit ses investissements dans les talents qui réalisent les productions. Grâce à son programme de formation à la diffusion (BTP), la société offre des perspectives de carrière intéressantes aux jeunes professionnels des pays hôtes. Pour Milano Cortina 2026, quelque 650 étudiants de la région rejoindront l’équipe d’OBS afin de bénéficier d’une expérience pratique au cœur de la diffusion des Jeux. Depuis Paris 2024, le BTP accueille aussi des olympiens et des paralympiens en reconversion vers les métiers des médias, tandis qu’un programme spécifique de formation aux commentaires olympiques aide les anciens athlètes à trouver leur voix derrière le micro."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 58-title\" style=\"top:136px;left:44px;\" src=\"/125/static/_content/58-title-1.png\"/>\n        <img class=\"abs halfScale 58-title\" style=\"top:185px;left:59px;\" src=\"/125/static/_content/58-title-2.png\"/>\n        <img class=\"abs halfScale 58-sub\" style=\"top:347px;left:45px;\" src=\"/125/static/_content/58-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim.staggerFromTo(cOf(\"58-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"58-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg58Anim.stop();\n        }\n      ",
    "searchText": "DE RETOUR SUR  la glace olympique  DANS UN ENTRETIEN EXCLUSIF POUR LA REVUE OLYMPIQUE, SAM REINHART SE LIVRE SUR CE QUE REPR…SENTE LíOPPORTUNIT… DE PARTICIPER AUX JEUX OLYMPIQUES DíHIVER POUR LES JOUEURS DE LA NATIONAL HOCKEY LEAGUE (NHL) APR»S 12 ANN…ES DíABSENCE. 1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  59  Numéro 125  A  u moment où j’ai appris que j’étais sélectionné pour Milano Cortina 2026, c’était entre la finale de la Eastern Conference et celle de la Coupe Stanley. On était donc en pleine préparation, mais je me souviens de mon excitation après ce coup de fil de Doug Armstrong [directeur général de l’équipe olympique masculine du Canada]. J’avais évidemment plein d’autres choses en tête à ce moment-là, mais ça m’a poussé à jouer encore mieux en finale, pour prouver au sélectionneur qu’il avait eu raison de me choisir ! L’absence des joueurs évoluant en NHL aux précédents Jeux, ça fait cogiter : on se demande si on aura une autre opportunité comme celle-ci. Certaines choses sont hors de notre contrôle, bien sûr, et certains joueurs auraient peut-être pu y participer cinq ou six fois au cours de leur carrière... Mais pour moi, le timing est parfait et j’ai hâte d’y être.  Faire la fierté du Canada 1 Sam Reinhart espère reproduire le succès du Canada au niveau international sur la scène olympique. 2 Il a eu un rôle clé dans les deux succès consécutifs des Panthers en Coupe Stanley.  En NHL, je suis entouré de compatriotes canadiens, que ce soit dans le vestiaire ou en dehors de la patinoire. Mais représenter son pays, c’est une sensation réellement unique. Chez les Canadiens, il se passe quelque chose d’indescriptible quand on enfile ce maillot... C’est vrai pour tous les matches internationaux, mais là on parle des Jeux Olympiques ! C’est encore plus fort : tout le pays est derrière toi  2  et tu as le privilège de jouer en leur nom. Et ça, l’équipe en est parfaitement consciente. Quand je pense aux Jeux Olympiques, le premier mot qui me vient, c’est « fierté ». C’est un événement que tout le monde regarde, au Canada. En fait, ma dernière année à Vancouver avant de déménager, c’était en 2010. On avait eu deux ou trois semaines de vacances scolaires : je n’avais pas cours et j’ai pu assister à quelques matches de hockey aux Jeux et voir le Canada jouer. Quand j’étais gamin, j’allais souvent aux matches des Vancouver Canucks, mais pendant les Jeux de Vancouver 2010, la patinoire était métamorphosée, vue de l’extérieur comme à l’intérieur. Les organisateurs avaient fait un boulot extraordinaire, ça démontrait l’importance que le monde entier accordait aux Jeux.  Une forme qui tombe à pic En NHL, on dispute 82 matches de saison régulière durant l’année. C’est impossible d’être à 100 % de ses capacités à chaque rencontre. L’objectif, c’est donc de gérer son effort pour atteindre son pic de forme quand ça compte le plus. Indéniablement, les Jeux sont l’un de ces moments où nous voulons tous être au sommet. Quand on regarde le calendrier de la NHL, le mois de janvier est particulièrement chargé. Je pense donc qu’on devra prendre le temps de se reposer dès qu’on en aura l’occasion pour être au meilleur niveau quand l’heure sera venue. Quelle importance j’accorderais à une médaille d’or olympique dans ma carrière ? Je la mettrais au même niveau qu’une Coupe Stanley. Avec les Jeux Olympiques, ce sont les deux trophées auxquels on pense en grandissant, en se disant : « C’est ça, le sommet du sport ». Et pour nous, en tant qu’équipe, je crois qu’un autre résultat que la médaille d’or serait considérée comme un échec.  Sam Reinhart est une figure centrale du hockey sur glace canadien actuel : il a remporté les Championnats du monde juniors de l’IIHF en 2015 et actifs en 2016. En NHL, il est devenu un buteur régulier et l’un des piliers des Florida Panthers, contribuant à leurs victoires en Coupe Stanley en 2024 et 2025."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n\n        <a href=\"https://newsroom.olympics.com/record/1670\" target=\"_blank\"><img class=\"halfScaleC halfpulse animatedpulse pointer z-index-set\" src=\"/125/static/_content/play-btn.png\" style=\"top:168px;left:444px;\" /></a>\n \n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "60  Le retour de la NHL  Peterka « Les joueurs de la NHL élèveront JJJ Allemagne, A Utah Mammoth U le niveau de la compétition » J Des stars de la NHL – nouveaux venus et légendes des précédents Jeux – partagent leur sentiment sur Milano Cortina 2026.  Sidney Crosby Canada, Pittsburgh Penguins  L  orsque vous êtes enfant, vous rêvez de participer aux Jeux Olympiques et d’y jouer au hockey. Pour l’avoir vécu, je peux vous dire que c’est vraiment à part et je pense que tout le monde est impatient et motivé d’avoir cette opportunité. [...] Essayez de savourer cette expérience autant que possible, car c’est vraiment unique. Bien sûr, on veut tous remporter la médaille d’or. C’est pour ça qu’on y va. Mais en même temps, vivez pleinement cette aventure et tirez-en le maximum.  Erik Karlsson SuËde, Pittsburgh Penguins  J  ' ’étais ado quand j’ai vu la Suède décrocher le titre [à Turin 2006] à la télévision. Aujourd’hui, j’ai le sentiment d’avoir la même chance qu’eux, et je ferai tout pour la saisir – pour inspirer à mon tour la prochaine génération qui nous regardera. J’ai vécu de très bons moments à Sotchi [2014]. C’est la seule édition des Jeux à laquelle j’ai eu la chance de participer et j’ai vraiment savouré toute cette expérience. Pas seulement d’y jouer au hockey, mais d’être entouré d’athlètes et de voir des sports que je regardais à la télévision en grandissant. Je dis toujours que c’est une occasion rare et spéciale de participer aux Jeux Olympiques, peu importante votre expérience. Les Jeux Milano Cortina 2026 vont être une belle édition.  e suis super enthousiaste à l’idée de me préparer pour Milano Cortina 2026. Les joueurs M de la NHL font leur retour aux Jeux Olympiques après 12 ans d’absence, et c’est incroyable d’en faire partie. J’ai toujours regardé les Jeux à la télévision et voulu en faire partie. Et maintenant, je vais représenter l’Allemagne et porter l’aigle sur ma poitrine. C’est un immense honneur. Jouer aux côtés des joueurs de la NHL et prendre part à cet événement international, c’est vraiment excitant. Le retour d’autant de joueurs de la NHL va élever le niveau de la compétition et ajouter une intensité incroyable sur la glace. Jouer avec et contre les meilleurs joueurs du monde, qui représentent chacun leur pays, rendra le jeu plus rapide, compétitif et imprévisible. C’est l’occasion de voir le hockey à son meilleur niveau sur la scène internationale. Mieux, le fait de vivre au village olympique, de faire partie de cet environnement, c’est quelque chose qu’on ne peut vivre que tous les quatre ans. Ce sera une expérience à part que d’être entouré d’autant d’énergie et d’athlètes de talent."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 62-title\" style=\"top:208px;left:59px;\" src=\"/125/static/_content/62-title-1.png\"/>\n        <img class=\"abs halfScale 62-title\" style=\"top:278px;left:136px;\" src=\"/125/static/_content/62-title-2.png\"/>\n        <img class=\"abs halfScale 62-title\" style=\"top:366px;left:63px;\" src=\"/125/static/_content/62-title-3.png\"/>\n        <img class=\"abs halfScale 62-title\" style=\"top:470px;left:63px;\" src=\"/125/static/_content/62-title-4.png\"/>\n        <img class=\"abs halfScale 62-title\" style=\"top:579px;left:56px;\" src=\"/125/static/_content/62-title-5.png\"/>\n        <img class=\"abs halfScale 62-sub\" style=\"top:744px;left:132px;\" src=\"/125/static/_content/62-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg62Anim = new TimelineMax();\n          pg62Anim.staggerFromTo(cOf(\"62-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"62-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 2)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg62Anim.stop();\n        }\n      ",
    "searchText": "62  Dans l’œil des athlètes  Milano Cortina  DANS LåIL DES ATHL»TES ALORS QUE LíEFFERVESCENCE GRANDIT ¿ LíAPPROCHE DE MILANO CORTINA 2026, DES CHAMPIONS AGUERRIS ET DES …TOILES MONTANTES NOUS PARTAGENT LEURS ESPOIRS ¿ PROPOS DE CES JEUX. ENTRE ENVIE DíACCUEILLIR SON PUBLIC « ¿ LA MAISON » ET D…SIR DE CONSOLIDER UN H…RITAGE, CET HIVER, UNE NOUVELLE PAGE DíHISTOIRE Sí…CRIRA DANS LES ALPES ITALIENNES."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  Numéro 125  63"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 64-name\" style=\"top:378px;left:26px;\" src=\"/125/static/_content/64-name-1.png\"/>\n        <img class=\"abs halfScale 64-name\" style=\"top:449px;left:27px;\" src=\"/125/static/_content/64-quote-1.png\"/>\n        <img class=\"abs halfScale 64-sub\" style=\"top:543px;left:55px;\" src=\"/125/static/_content/64-sub-1.png\"/>\n\n        <a href=\"https://www.olympics.com/en/video/scotty-james-s-silver-medal-in-snowboard-halfpipe-beijing-2022\" target=\"_blank\">\n          <img class=\"halfScaleC halfpulse animatedpulse pointer z-index-set\" src=\"/125/static/_content/play-btn.png\" style=\"top:317px;left:467px;\" />\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.staggerFromTo(cOf(\"64-name\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"64-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg64Anim.stop();\n        }\n      ",
    "searchText": "64  Dans l’œil des athlètes  1  Scotty James ´ JE SUIS TR»S FIER DíÊTRE AUSTRALIEN ª SCOTTY JAMES REVIENT SUR SON PARCOURS OLYMPIQUE, ENTAM… ¿ Lí¬GE DE 15 ANS, ET NOUS D…VOILE COMMENT IL SE PR…PARE POUR SES CINQUI»MES JEUX ¿ MILANO CORTINA 2026.  C  hampion australien de halfpipe, Scotty James a parcouru du chemin depuis ses débuts olympiques à 15 ans. Le plus jeune olympien à Vancouver en 2010 est aujourd’hui un athlète qui, du haut de ses 31 ans, s’est arrogé sept médailles d’or aux Winter X Games et quatre titres en Championnats du monde. Mais l’or olympique lui fait encore défaut… Après le bronze à PyeongChang 2018 et l’argent à Beijing 2022, Scotty James a à cœur de compléter son tableau de médailles à Milano Cortina 2026 où il deviendra le quatrième Australien à avoir concouru lors de cinq éditions de Jeux d’hiver. Fort de son palmarès aux Winter X Games et aux Championnats du monde en 2025, Scotty James est porté par une motivation nouvelle, avec la naissance de son premier enfant fin 2024. Lui qui pourrait faire figure de vétéran du circuit de snowboard restera l’homme à battre en Italie.  ."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  ´  65  Numéro 125  Je suis très heureux de ma saison l’an dernier. Je me sens dans une bonne dynamique avant les Jeux et mon équipe m’a concocté un excellent programme pour cette année. Je compte donc poursuivre sur cette trajectoire. Je m’entraîne en Australie, c’est génial ! J’ai pris beaucoup de plaisir sur le halfpipe aménagé à Thredbo l’an dernier. Ça fait toute la différence de s’entraîner sur une piste en conditions réelles, dans son pays. Dans ma carrière, j’ai souvent dû partir à l’étranger. Avoir accès à cette piste, aujourd’hui, c’est un événement – pour moi, mais aussi pour la prochaine génération de snowboardeurs ! Les Jeux de Milano Cortina 2026 seront mes cinquièmes Jeux Olympiques [seuls trois autres Australiens ont un tel palmarès]. Je ne l’avais pas vu sous cet angle, mais cela mérite d’être souligné. Je suis honoré de faire partie de ce club exclusif ! Je suis aussi reconnaissant d’avoir vécu une expérience olympique si jeune. Lors de mes premiers Jeux, j’avais 15 ans. Aujourd’hui, j’ai presque l’impression d’être un vétéran,  mais au moins, je sais ce que représentent les Jeux et comment s’y préparer. Je me sens en pleine possession de mes moyens pour les affronter. J’ai vécu des moments exceptionnels dans ma carrière, notamment quand j’ai remporté des médailles. Mais pour moi, le plus inoubliable reste le défilé des athlètes en 2018, quand j’ai eu le privilège d’être porte-drapeau de l’équipe d’Australie. C’était un grand honneur d’avoir été choisi. La photo de ce temps fort restera accrochée à jamais dans mon bureau. Je suis très fier d’être Australien, car nous sommes très peu nombreux sur le circuit mondial. C’est comme un complexe d’infériorité qui serait devenu un moteur. Peu importe mes origines et mon parcours, je viens pour me battre et l’emporter. Avec un passeport australien, tu as le choix entre relever ce défi ou le subir. La question de l’or olympique a longtemps été un tabou. J’avais tendance à éviter le sujet, peut-être parce qu’il ajoute, je l’avoue, une pression supplémentaire. Mais je me suis rendu compte que  j’aime cette pression. Quand je m’élance en compétition, je le fais avec la ferme intention de gagner. C’est la raison pour laquelle je n’hésite pas à partir loin de ma famille et que je consens à tous ces sacrifices. Je suis toujours déterminé à performer exactement comme je l’ai pensé. Si, au final, il y a une médaille d’or, c’est formidable. S’il n’y en a pas, j’ai tout de même le sentiment du travail accompli. Je ne suis pas du genre suiveur, je veux tenir la barre du bateau. Je ne veux pas arriver en février et me dire : “Waouh, les gars arrivent à enchaîner les triples corks ? Il faudrait que je m’y mette.” Le jour où tu ne veux plus évoluer, c’est le moment de raccrocher. Pour plaisanter, je me compare souvent à une mauvaise odeur persistante ! Mais, pour moi, la ténacité est  2  une qualité et j’ai encore beaucoup à apprendre. Au début, j’étais inquiet de devenir papa et de continuer mon activité de sportif car le sport est égoïste, surtout quand ton moteur, c’est la gagne. Honnêtement, la naissance de mon fils n’a rien changé pour moi, sur la neige. Je dirais même que depuis, j’ai élargi ma vision de la vie. J’oublie très vite les jours où rien ne va à l’entraînement. Parce qu’ensuite, je retrouve ce petit être extraordinaire qui a besoin de moi, quoi qu’il arrive. Si j’ai la chance que tout se passe comme je l’entends en Italie, je n’hésiterais pas à le réveiller pour lui montrer ma médaille. ■ 1 Scotty James a décroché une médaille d’argent en halfpipe à Beijing 2022. 2 Il a été porte-drapeau de l’équipe d’Australie à PyeongChang 2018."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 66-name\" style=\"top:123px;left:34px;\" src=\"/125/static/_content/66-name-1.png\"/>\n        <img class=\"abs halfScale 66-name\" style=\"top:192px;left:29px;\" src=\"/125/static/_content/66-quote-1.png\"/>\n        <img class=\"abs halfScale 66-sub\" style=\"top:355px;left:54px;\" src=\"/125/static/_content/66-sub-1.png\"/>\n\n        <a href=\"https://www.olympics.com/en/milano-cortina-2026/news/figure-skaing-cup-of-china-2025-cha-junhwan-feature\" target=\"_blank\" class=\"addContentLink\" style=\"top:372px; left:268px; width:32px; height:16px;\"></a>  \n        <a href=\"https://www.olympics.com/en/milano-cortina-2026/news/figure-skaing-cup-of-china-2025-cha-junhwan-feature\" target=\"_blank\" class=\"addContentLink\" style=\"top:390px; left:53px; width:68px; height:16px;\"></a>  \n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.staggerFromTo(cOf(\"66-name\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"66-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg66Anim.stop();\n        }\n      ",
    "searchText": "66  Dans l’œil des athlètes  1  Cha Junhwan  ´ LES ATHL»TES VONT VIVRE UNE FORMIDABLE EXP…RIENCE. ª  DE SES D…BUTS OLYMPIQUES ¿ PYEONGCHANG ¿ SES NOUVEAUX RÊVES EN ITALIE, CHA JUNHWAN NOUS RACONTE LA PASSION QUI A TOUJOURS GUID… SON PATINAGE.  C  ha Junhwan incarne le début d’une nouvelle ère dans le patinage artistique sud-coréen. Pionnier pour son pays, il est le premier Sud-Coréen à s’être hissé sur le podium mondial. Il cumule les records nationaux, avec neuf victoires consécutives aux Championnats sud-coréens entre 2017 et 2025. Son patinage élégant, exécuté avec une grande expressivité, a fait de lui un prétendant régulier aux titres du circuit du Grand Prix, admiré pour sa maîtrise et son charisme sur la glace. Fort d’une confiance et d’une expérience renouvelées, ce double olympien a désormais Milano Cortina 2026 en ligne de mire. En dehors des patinoires, il est devenu un modèle pour la génération montante de patineurs sud-coréens."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  67  Numéro 125  2  ´  Quand j’ai commencé à patiner à 8 ans, j’étais attiré par la sensation de liberté que cela me procurait. Pouvoir exprimer mes sentiments à travers la musique et le mouvement faisait, à mes yeux, tout l’intérêt de ce sport. Mon premier souvenir olympique remonte à Vancouver 2010. Derrière mon téléviseur, j’ai été profondément ému par la ferveur des patineurs pendant leur programme. La passion qui les animait m’a marqué et certainement inspiré. Accueillir les Jeux dans son pays n’arrive qu’une fois dans une vie et je l’ai vécu à  PyeongChang en 2018 ! À cette époque, j’avais accumulé les blessures et les difficultés. Mais j’étais déterminé à en être et à concourir. Si les Jeux sont en soi un événement hors du commun, quand ils se déroulent à domicile, c’est encore plus inédit ! Avant ces Jeux, j’étais très nerveux, mais dès que j’ai posé un pied sur la glace, j’ai savouré le moment et je suis resté ancré dans ma prestation. Je me rappelle du slogan « Passion. Connected » de PyeongChang 2018. C’est ce que j’ai ressenti pendant les Jeux en Corée du Sud. J’étais si fier et honoré d’évoluer devant mon public pour ma première participation ! Ces débuts olympiques ont dopé ma motivation et m’ont aidé à grandir comme athlète pendant les quatre années  entre PyeongChang et Beijing. Aux Jeux de Beijing 2022, j’ai aimé la compétition. Mais, à cause du COVID, je n’ai pas pu vivre pleinement l’expérience olympique. Je suis très enthousiaste à l’approche de Milano Cortina 2026. Je suis impatient de découvrir le village olympique en compagnie des autres athlètes et de voir l’accueil que l’Italie réservera au monde. Ces Jeux seront, pour moi, les premiers hors d’Asie. Je pense que les athlètes vont vivre une formidable expérience. J’ai déjà concouru en Italie, je sais que les spectateurs et le public italiens sont des passionnés et que leur énergie rejaillit sur les athlètes. J’ai déjà hâte de ressentir la ferveur et l’émotion des supporteurs en tribune. J’espère que cette vitalité  se reflètera dans l’exécution de mon programme. Côté sportif, j’ai continué à me challenger cette saison. Je me suis entraîné d’arrachepied afin de perfectionner mes passages sur la glace. Ce genre de trajectoire n’est jamais linéaire, mais j’avance dans la bonne direction et j’ai encore le temps de progresser avant les Jeux. Pour mon programme court, qui raconte mon histoire personnelle, je mise sur l’émotion. Quant à mon programme libre, sur le thème du Moulin Rouge, il parle de passion et d’amour éternel. J’ai hâte de les partager avec le monde. Évidemment, un athlète espère toujours obtenir de bons résultats et des médailles, mais mon objectif premier, c’est l’immersion totale. Je veux plonger entièrement dans l’événement, vivre pleinement chaque moment afin de repartir sans regret. Ce sera, pour moi, la recette de la réussite à Milano Cortina 2026. ■  1 Cha Junhwan a terminé à la cinquième place en individuel hommes à Beijing 2022. 2 Ses débuts olympiques ont eu lieu à domicile, lors des Jeux Olympiques d’hiver de PyeongChang 2018."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 68-name\" style=\"top:106px;left:40px;\" src=\"/125/static/_content/68-name-1.png\"/>\n        <img class=\"abs halfScale 68-name\" style=\"top:182px;left:29px;\" src=\"/125/static/_content/68-quote-1.png\"/>\n        <img class=\"abs halfScale 68-sub\" style=\"top:305px;left:58px;\" src=\"/125/static/_content/68-sub-1.png\"/>\n\n        <a href=\"https://www.olympics.com/en/milano-cortina-2026/news/flora-tabanelli-freeski-interview-freedom-self-expression\" target=\"_blank\" class=\"addContentLink\" style=\"top:302px; left:54px; width:117px; height:16px;\"></a>  \n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim.staggerFromTo(cOf(\"68-name\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"68-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg68Anim.stop();\n        }\n      ",
    "searchText": "68  Dans l’œil des athlètes  1  Flora Tabanelli  ´ QUE CES JEUX OLYMPIQUES SE D…ROULENT EN ITALIE, C’EST UN RÊVE DEVENU R…ALIT…. ª FLORA TABANELLI REVIENT SUR SON ASCENSION FULGURANTE EN AMONT DE MILANO CORTINA 2026 ET NOUS EXPLIQUE COMMENT LE SKI ACROBATIQUE LUI PERMET DíEXPRIMER TOUTE LA PALETTE DE SA PERSONNALIT…."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  69  Numéro 125  2  F  lora Tabanelli est l’une des étoiles montantes d’Italie. Avec son ski acrobatique plein d’audace, la championne semble n’avoir peur de rien sur les pentes enneigées. Suite à des performances remarquables aux Jeux Olympiques de la Jeunesse d’hiver de Gangwon 2024, la voilà propulsée sur le devant de la scène internationale, après un doublé en or, dans l’épreuve de slopestyle et en big air. Ces succès n’ont fait que confirmer ce que les spécialistes avaient déjà identifié : l’émergence d’un nouveau talent italien. Dans les mois qui ont suivi les Jeux Olympiques de la Jeunesse d’hiver de Gangwon 2024, Flora Tabanelli s’est encore surpassée, remportant des victoires en big air aux Championnats du monde de ski acrobatique de la FIS et aux Winter X Games. Le regard désormais rivé vers Milano Cortina 2026, la jeune fille incarne une nouvelle génération de skieurs italiens alliant le talent à la détermination.  1 Flora Tabanelli a remporté l’or dans les épreuves de big air et slopestyle à Gangwon. 2 Elle veut briller à Livigno avec des ﬁgures innovantes.  ´  Mon parcours sportif a commencé dès l’enfance. Ma mère m’a offert ma première paire de skis quand j’avais 2 ans et mes parents nous ont toujours encouragés, avec mes frères et sœurs, à essayer différents sports et à poursuivre dans la voie qui nous plaisait. En grandissant, j’ai à peu près tout testé, dont le ski alpin, le snowboard cross et le patinage. Quand j’ai débuté le ski acrobatique il y a quatre ans, j’ai immédiatement adoré ! J’ai senti que j’allais pouvoir m’y exprimer en toute liberté. Les figures et les mouvements en ski acrobatique sont à la portée de chacun, mais il faut arriver à y apposer sa marque de fabrique, qui fera la différence. Moi qui suis une fille timide dans la vie courante, en compétition, j’ai le sentiment d’être moi-même. Gangwon 2024 a été ma première participation olympique – une expérience incroyable ! Cela n’a pas été facile de décrocher ces deux médailles d’or. J’ai dû m’adapter à la neige et aux conditions. Pendant les épreuves, j’ai essayé de faire  comme pour n’importe quelle course du circuit. Après, la folie s’est emparée des spectateurs, venus en foule, ce qui a donné une teneur singulière à l’événement, que je n’oublierai jamais. Vivre au village olympique, en un même lieu, dans une ambiance où sont réunis tous les athlètes originaires de pays différents, qui pratiquent des sports différents, c’est ainsi qu’on comprend l’essence des Jeux Olympiques. Aujourd’hui, je suis focalisée sur Milano Cortina. Le rêve est devenu réalité car je vais participer aux Jeux, en Italie ! Livigno, le site des épreuves de ski acrobatique, est un peu ma deuxième maison, ce qui devrait jouer en ma faveur. Mais, l’épreuve aura lieu sur une nouvelle piste, que je n’ai jamais essayée. L’ambiance sera fantastique grâce aux nombreux supporteurs italiens qui vont s’enthousiasmer pour ces Jeux. Pour nous, les athlètes italiens, ce sera formidable car nos amis et nos familles seront présents au bord de la piste. Je sais que les  Italiens encourageront aussi les athlètes étrangers, comme s’ils étaient chez eux, dans une ambiance chaleureuse. La pression sera un peu plus forte sur nos épaules car nous serons en première ligne, sous le regard attentif des fans italiens en attente de performances. Moi, je compte aborder ces Jeux comme une compétition ordinaire. Bien sûr, quand on est engagé, on veut des résultats ! Si je m’élance avec passion et que j’exécute les figures comme je le souhaite, je serai la plus heureuse, peu importe mon rang au classement final ! ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 70-name\" style=\"top:123px;left:30px;\" src=\"/125/static/_content/70-name-1.png\"/>\n        <img class=\"abs halfScale 70-name\" style=\"top:195px;left:29px;\" src=\"/125/static/_content/70-quote-1.png\"/>\n        <img class=\"abs halfScale 70-sub\" style=\"top:326px;left:44px;\" src=\"/125/static/_content/70-sub-1.png\"/>\n\n        <a href=\"https://www.olympics.com/fr/athletes/martin-fourcade\" target=\"_blank\" class=\"addContentLink\" style=\"top:323px; left:41px; width:127px; height:16px;\"></a> \n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.staggerFromTo(cOf(\"70-name\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"70-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg70Anim.stop();\n        }\n      ",
    "searchText": "70  Dans l’œil des athlètes  1  Martin Fourcade  ´ L’ITALIE [Ö] A UNE HISTOIRE PRIVIL…GI…E AVEC LES SPORTS D’HIVER. ª MARTIN FOURCADE EST CONVAINCU QUE LES JEUX DE MILANO CORTINA SERONT INOUBLIABLES POUR LES ATHL»TES ET QUíILS D…FINIRONT UNE NOUVELLE NORME ¿ LíAVENIR.  M  artin Fourcade, l’olympien français le plus titré en sports d’hiver de tous les temps, a dominé le biathlon pendant une décennie, remportant sept médailles olympiques, dont six en or, et 13 titres mondiaux. Ce modèle de régularité et de précision a été sept fois vainqueur du classement général de la Coupe du monde, de 2012 à 2018 – un record jamais égalé en sport ! Depuis qu’il a pris sa retraite après la saison 2019-2020, il reste très investi au sein du Mouvement olympique. Membre de la commission des athlètes du CIO et président de la commission des athlètes de Paris 2024, il a été, lors de ces derniers Jeux d’été, à l’origine de projets centrés sur les athlètes, comme le Parc des Champions."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  71  Numéro 125  1 Martin Fourcade est l’un des athlètes olympiques d’hiver les plus décorés de tous les temps. 2 Le Français a décroché trois médailles d'or à PyeongChang 2018.  ´  Pour la première fois depuis longtemps aux Jeux Olympiques, le biathlon est de retour dans ce que j’appellerais un “site traditionnel”. La vallée d’Anterselva est un splendide écrin pour accueillir ce sport. J’ai débuté le ski de fond car j’aime la montagne, la nature et la forêt. Selon moi, la vallée d’Anterselva allie les trois ! L’endroit a aussi une résonnance particulière pour moi. Lors de mes derniers Championnats du monde en 2020, j’y ai remporté mon premier titre en relais par équipes et c’est le moment où j’ai décidé de mettre un terme à ma carrière. Je n’en ai parlé à personne ce jour-là, mais en mon for intérieur, je savais que ma décision était prise. Impossible d’oublier une seule victoire remportée au cours de mon parcours, mais celle-là a marqué un tournant dans ma vie. L’Italie et les Alpes ont une histoire privilégiée avec les sports d’hiver. Enfant, je  Hommage aux champions Lors de Paris 2024, le Parc des Champions accueillait les athlètes au moment de recevoir leurs médailles, au milieu de milliers de supporters enthousiastes. Les sportifs qui se sont vus remettre une médaille réattribuée au titre d’une précédente édition, suite à la disqualification d’un concurrent, ont également eu droit à une cérémonie dans ce parc pour fêter leurs précédentes victoires. En tant que président de la commission des athlètes de Paris 2024, Martin Fourcade a été l’artisan, entre autres, du Parc des Champions. Il recevra une médaille d’or à Milano Cortina 2026, après  avoir remonté dans le classement de la mass-start (15 km) hommes de Vancouver 2010. « C’est l’occasion d’envoyer un message positif au monde entier et d’assister, des années plus tard, à la victoire du sport et de la justice, indique Martin Fourcade. J’ai vraiment hâte de vivre cette expérience devant les amateurs de biathlon à Milano Cortina 2026. »  2  rêvais de participer aux Jeux. C’est à Turin 2006 que le rêve a commencé à prendre forme. J’encourageais mon frère aîné sur les pistes et je commençais à participer à des compétitions de niveau national, quand j’ai réalisé que le rêve pouvait devenir réalité. Je sais d’expérience que l’ambiance des prochains Jeux Olympiques et l’hospitalité italienne seront au rendez-vous pour nous offrir des moments d’exception. Milano Cortina 2026 peut également être un modèle pour l’avenir des sports d’hiver. La plupart des sites accueillent déjà régulièrement des épreuves de Coupe du monde. Un nouveau modèle est en marche, avec des Jeux plus flexibles, qui s’adaptent au territoire dans lequel ils sont organisés, et non l’inverse. En sports d’hiver, nous sommes aujourd’hui obligés de prendre en compte l’ensemble des enjeux extérieurs, notamment le changement climatique, et de continuer à évoluer. Avec les Jeux de Milano Cortina et l’édition suivante dans les Alpes françaises, nous aurons la chance extraordinaire de pouvoir façonner l’avenir des Jeux d’hiver. Pour ce qui est du biathlon, je suis très fier des nombreuses épreuves par équipes mixtes aux Jeux  Olympiques. Je tire mon chapeau à ma discipline et à ma Fédération Internationale car le biathlon fait partie des sports qui ont mis en place des compétitions mixtes au plus haut niveau avec une longueur d’avance sur les autres. Côté olympique, de nombreuses épreuves font aussi s’affronter des hommes et des femmes sur l’aire de compétition. Les messages positifs ainsi envoyés sont très porteurs pour l’avenir des sports d’hiver. Enfant, je me suis inspiré de solides modèles féminins et masculins. Je me réjouis que la mixité se généralise au sein du Mouvement olympique. Le programme sportif des Jeux d’hiver connaît des innovations constantes. De nouvelles disciplines font leurs débuts olympiques, comme le ski-alpinisme. Cette idée d’étoffer le programme sportif d’une édition à l’autre me plaît. Les Jeux en ressortent grandis et avec ces nouveaux entrants, ils captent de nouveaux publics, ce qui enrichit la diversité. Fervent supporteur de l’innovation, j’ai hâte d’être à Milano Cortina 2026 pour voir comment ces Jeux se dérouleront. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 72-title\" style=\"top:609px;left:95px;\" src=\"/125/static/_content/72-title-1.png\"/>\n        <img class=\"abs halfScale 72-title\" style=\"top:703px;left:70px;\" src=\"/125/static/_content/72-title-2.png\"/>\n        <img class=\"abs halfScale 72-sub\" style=\"top:825px;left:96px;\" src=\"/125/static/_content/72-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg72Anim = new TimelineMax();\n          pg72Anim.staggerFromTo(cOf(\"72-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"72-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg72Anim.stop();\n        }\n      ",
    "searchText": "De gauche à droite : Mikaela Shiffrin ; Stefania Constantini et Amos Mosaner ; et Chloé Trespeuch.  Les visages  DES JEUX DES JOURNALISTES SPORTIFS VENUS DE DIFF…RENTES R…GIONS DU MONDE LIVRENT LEURS ANALYSES SUR LES ATHL»TES ¿ SUIVRE ¿ MILANO CORTINA 2026."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 74-title\" style=\"top:111px;left:52px;\" src=\"/125/static/_content/74-title-1.png\"/>\n        <img class=\"abs halfScale 74-sub\" style=\"top:202px;left:51px;\" src=\"/125/static/_content/74-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.staggerFromTo(cOf(\"74-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"74-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg74Anim.stop();\n        }\n      ",
    "searchText": "74  Les visages des Jeux  Comme à la maison u e a B o ngi o  v  ni  P ar  r nd  an  A  LíITALIE VISE UN NOMBRE RECORD DE M…DAILLES EN CAPITALISANT SUR LíAVANTAGE DE « JOUER ¿ LA MAISON » ¿ MILANO CORTINA 2026.  Journaliste au quotidien italien La Gazzetta dello Sport, Andrea Buongiovanni est basé à Milan. Son aventure olympique a commencé à Salt Lake City en 2002 et Milano Cortina 2026 sera sa douzième édition des Jeux. Il attend cet événement avec impatience, d’autant plus qu’il se déroulera, selon ses mots, « dans le jardin de sa propre maison ».  V  ingt médailles : tel est l’ambitieux objectif de l’équipe italienne pour les Jeux Olympiques d’hiver de Milano Cortina 2026. Elle qui en a remporté 17 à Beijing en 2022 égalerait alors son record atteint aux Jeux de Lillehammer en 1994. Cette année-là, Manuela Di Centa avait brillé avec quatre médailles en ski de fond (deux d’or, deux d’argent et une de bronze), avant que les Azzurri ne raflent sept médailles d’or, cinq d’argent et huit de bronze. Réitérer cet exploit sera difficile, mais pas impossible : en plus d’avoir l’avantage du terrain, l’équipe italienne dispose d’athlètes de haut niveau dans bon nombre de disciplines de neige et de glace – avec toutefois quelques lacunes. Petite particularité : sur le papier, ce sont surtout les femmes qui devraient être sur le devant de la scène. Comme souvent, c’est le ski alpin qui suscite le plus d’attente, en particulier les épreuves féminines prévues à Cortina où, espérons-le, deux reines seront à l’honneur : Sofia Goggia et Federica Brignone. La première avait été désignée porte-drapeau il y a quatre ans en Chine, mais une énième blessure l’avait privée de participation. Blessures et convalescences l’ont également empêchée de se montrer à la hauteur de sa réputation la saison dernière. Elle est désormais rétablie ; or, lorsque la forme physique est au rendez-vous, elle peut s’avérer redoutable. Elle l’a d’ailleurs confirmé en janvier 2025 en triomphant lors de la dernière épreuve de descente de la Coupe du monde disputée sur l’une des pistes les plus emblématiques au monde, l’Olimpia delle Tofane, qui sera également le théâtre de l’épreuve olympique. La bergamasque de 33 ans y a déjà remporté cinq victoires et a bien l’intention d’accroître son palmarès.  Federica Brignone, première au classement général la saison dernière, avec deux victoires en Coupe du monde dans deux disciplines différentes, 11 victoires sur le circuit et une médaille d’or en géant à son actif, devrait aussi jouer un rôle de premier plan, même si la grave blessure au genou gauche subie début avril porte une ombre au tableau. La valdôtaine de 35 ans est aujourd’hui engagée dans une difficile course contre la montre. Toujours en ski mais de fond cette fois, Federico Pellegrino est l’homme de la situation. Lui aussi originaire de la Vallée d’Aoste, lui aussi âgé de 35 ans, avec de l’expérience à revendre et deux médailles d’argent olympiques au compteur, il sera un formidable adversaire dans les sprints à Tesero. En biathlon, Dorothea Wierer, avec ses trois médailles de bronze aux trois derniers Jeux, est une force avec laquelle il faudra compter : la Sud-Tyrolienne, également née en 1990, est une athlète hors pair lorsque sa forme est au rendez-vous. Elle concourra dans son fief à Anterselva ; elle connaît tous les secrets de ces pistes et de ces pas de tir et le soutien des supporters pourrait s’avérer fondamental. Autre neige, celle du snowboard et de Livigno, avec des stars tant en slalom géant parallèle qu’en cross. Maurizio Bormolini, vainqueur de la Coupe du monde en 2024, se produira également à domicile et pourrait devenir l’une  1 Ce seront les sixièmes Jeux Olympiques d’Arianna Fontana. 2 Stefania Constantini et Amos Mosaner tenteront de conserver leur titre olympique en curling remporté à Beijing 2022."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  75  Numéro 125  des figures de proue des Azzurri à Milano Cortina 2026. En cross, l’incroyable talent et l’enthousiasme contagieux de Michela Moioli, médaillée d’or à PyeongChang en 2018, portedrapeau à Beijing en 2022 et championne du monde en titre, pourraient faire la différence. Parmi tant de vétérans, une jeune star : Flora Tabanelli. À 18 ans, cette princesse du freestyle, détentrice du titre mondial de big air et première au classement général mondial, a déjà un palmarès olympique junior  impressionnant : porte-drapeau de l’équipe italienne aux Jeux Olympiques de la Jeunesse d’hiver de Gangwon 2024, elle remporte l’or en slopestyle et en big air ; il est aujourd’hui temps pour elle de confirmer l’exploit dans la cour des grands. Dans les sports de glace, la situation est tout aussi prometteuse avec tout d’abord l’Italienne la plus décorée aux Jeux d’hiver : Arianna Fontana, la comète du patinage de vitesse sur piste courte. Elle détient le record  1  2  de médailles olympiques italiennes toutes catégories et tous genres confondus. Avec ses 11 médailles olympiques, elle devance même des légendes telles que Stefania Belmondo (10), Giorgio Di Centa (7), Eugenio Monti et Armin Zoeggeler (6) ou encore Alberto Tomba (5). La patineuse de 35 ans, originaire de la Valteline, a commencé son épopée olympique avec les Jeux Olympiques de Turin 2006, où elle est montée sur le podium à 15 ans et 134 jours, restant à ce jour la plus jeune médaillée italienne des Jeux d’hiver. Décrocher une sixième médaille lors de sa sixième participation aux Jeux lui permettrait de boucler un cycle hors norme. En patinage de vitesse, tous les projecteurs sont braqués sur Davide Ghiotto, vainqueur des trois derniers titres mondiaux sur 10 000 mètres et détenteur du record du monde. Ces deux athlètes, leaders de l’équipe nationale, feront rêver le public milanais. À Cortina, le duo de curling Stefania ConstantiniAmos Mosaner enflammera le public local : entre le 6 et le 22 février, ils seront appelés, comme Arianna Fontana dans le 500 mètres, à confirmer leur triomphe de Beijing 2022. D’autres noms ? Dominik Paris (ski alpin), Francesco De Fabiani (ski de fond), Lisa Vittozzi (biathlon), Roland Fischnaller (snowboard), Valentina Margaglio (skeleton), Pietro Sighel (patinage de vitesse sur piste courte), Andrea Giovannini et Francesca Lollobrigida (patinage de vitesse), Sara Conti-Niccolò Macii et Charlene GuignardMarco Fabbri (patinage artistique)... Il y en aura pour tous les goûts. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 76-title\" style=\"top:101px;left:44px;\" src=\"/125/static/_content/76-title-1.png\"/>\n        <img class=\"abs halfScale 76-title\" style=\"top:221px;left:37px;\" src=\"/125/static/_content/76-title-2.png\"/>\n        <img class=\"abs halfScale 76-sub\" style=\"top:307px;left:45px;\" src=\"/125/static/_content/76-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg76Anim = new TimelineMax();\n          pg76Anim.staggerFromTo(cOf(\"76-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"76-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          removeContentLinks();\n          pg76Anim.stop();\n        }\n      ",
    "searchText": "76  Les visages des Jeux  Les femmes mènent la charge pour la Team USA LES ATHL»TES F…MININES JOUENT UN R‘LE MAJEUR DANS Lí…QUIPE OLYMPIQUE DES …TATS-UNIS, SUR LíAIRE DE COMP…TITION COMME EN DEHORS.  accardi  P ar  N  i  Z ck  C  ’est auprès des athlètes féminines que l’équipe olympique des États-Unis a principalement puisé sa force lors des derniers Jeux Olympiques – et cela devrait se confirmer à Milano Cortina 2026. Des légendes du ski alpin Mikaela Shiffrin et Lindsey Vonn, aux prodiges du patinage Erin Jackson et Alysa Liu, en passant par les pionnières Jessie Diggins et Chloe Kim, les championnes de bobsleigh et les mamans Kaillie Humphries et Elana Meyers Taylor : la Team USA est menée par des femmes, dont la plupart se rendront en Italie portées par des histoires uniques et captivantes. Le « Title IX »* a offert plus d’opportunités aux athlètes féminines américaines dès 1972, mais l’équipe olympique masculine a continué de remporter deux fois plus de médailles que la féminine aux Jeux d’hiver de 2002, 2006 et 2010. Depuis, à chaque édition – été comme  Nick Zaccardi couvre les sports olympiques pour NBCSports.com depuis 2013 et a assuré la couverture de six éditions des Jeux Olympiques.  1 Lindsey Vonn a remporté l’or en descente aux Jeux Olympiques de Vancouver 2010. 2 Kaillie Humphries a décroché le premier titre olympique de monobob en 2022.  1  hiver – les femmes américaines sont toujours au moins à égalité, voire devant les hommes, en termes de podiums. Ces athlètes-là ont grandi à une époque où l'impact du « Title IX » s'est fait sentir et ont eu des modèles auxquelles s’identifier. Lindsey Vonn était toute jeune lorsqu’elle a pu rencontrer son héroïne, Picabo Street, la médaillée d’or en super G des Jeux de 1998. Chloe Kim a pu voir Kelly Clark, médaillée d’or en 2002, repousser les limites du halfpipe. Hilary Knight, la capitaine de l’équipe américaine féminine de hockey sur glace, porte le maillot n° 21 en hommage à Cammi Granato, elle-même capitaine de la première équipe féminine de hockey championne olympique en 1998. Mais les athlètes féminines des États-Unis ne se contentent plus de dominer les terrains : elles gagnent également en influence en dehors. En février dernier, lorsque Mikaela Shiffrin a"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "atteint la barre des 100 victoires en Coupe du monde, elle a célébré cet exploit en s’associant à la fondation Share Winter pour lever 100 000 USD pour les programmes d’initiation au ski et au snowboard à destination des jeunes qui n’y auraient pas accès sans cela. Triple championne du classement général de la Coupe du monde en ski de fond, Jessie Diggins arbore depuis des années le message « The Emily Program » sur son bandeau. Ce programme national de traitement des troubles alimentaires lui a sauvé la vie au lycée : « Sur les pistes, je suis comme un livre ouvert : il est important pour moi d’afficher mon passé et mon présent, car ça ne devrait pas être quelque chose à cacher », a déclaré l’athlète par le passé. Elana Meyers Taylor a donné naissance à son premier enfant, Nico, entre la troisième et quatrième manche des Championnats du monde de l’IBSF 2020 et a pris un congé parental jusqu’au terme de la saison. Trois semaines avant la fin de sa grossesse, elle a enduré un travail de deux jours, avant une césarienne d’urgence. Pendant les huit jours que Nico a passés en soins intensifs néonatals, l’équipe médicale a confirmé qu’il souffrait du syndrome de Down, en plus d’une perte auditive neurosensorielle bilatérale profonde. Lors de son retour à la compétition pour la saison 2020/21, Elana Meyers Taylor portait sur son casque un autocollant de « GiGi’s Playhouse », un réseau qui offre gratuitement un accompagnement à vie aux personnes souffrant du syndrome de Down. Une bénévole de cette  2  association a été parmi les premières à prendre de ses nouvelles après son accouchement. Elana Meyers Taylor continue de militer en faveur des enfants souffrant de handicap. Son deuxième enfant, Noah, né en novembre 2022, souffre également de surdité. Elle a par ailleurs choisi de voyager avec ses deux enfants sur le circuit de la Coupe du monde, une décision difficile qu’elle est aujourd’hui heureuse d’avoir prise. Nico et Noah découvrent le monde et ils font désormais partie de la communauté du bobsleigh : ils reçoivent beaucoup d’amour non seulement de la part des coéquipiers de leur mère, mais aussi des athlètes du monde entier. Le parcours olympique d’Elana Meyers Taylor a débuté devant la télévision, lors de la retransmission des derniers Jeux Olympiques organisés en Italie – Turin 2006 – alors qu’elle jouait au softball à l’université. À l’époque, c’est l’une des femmes importantes de sa vie qui lui  a suggéré de s’essayer au bobsleigh : sa mère Jan, d’origine sicilienne. Forte d’un palmarès comptant cinq médailles olympiques – une de moins seulement que la détentrice du record féminin, la patineuse de vitesse américaine Bonnie Blair – Elana Meyers Taylor entend disputer à Milano Cortina 2026 sa cinquième et dernière édition des Jeux : « La seule chose qui me manque, c’est une médaille d’or olympique », a-t-elle déclaré en 2024 (son palmarès en compte trois d’argent et deux de bronze). « J’ai accompli tout le reste dans ce sport. Mais avoir l’opportunité de tenter une dernière fois d’aller la chercher… c’est une occasion que je ne peux pas laisser passer. » ■  *Loi historique sur les droits civiques qui a joué un rôle déterminant dans la promotion de l’égalité des genres dans le sport aux États-Unis."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 78-title\" style=\"top:124px;left:46px;\" src=\"/125/static/_content/78-title-1.png\"/>\n        <img class=\"abs halfScale 78-title\" style=\"top:180px;left:49px;\" src=\"/125/static/_content/78-title-2.png\"/>\n        <img class=\"abs halfScale 78-sub\" style=\"top:264px;left:45px;\" src=\"/125/static/_content/78-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.staggerFromTo(cOf(\"78-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"78-sub\"), 0.9, {opacity:0, y:30}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)\n        }\n          \n        function onPageLeave() {\n          pg78Anim.stop();\n        }\n      ",
    "searchText": "78  Les visages des Jeux  La France vise le Top 5 ac  h  r et ti el P  P ar  R  Lí…QUIPE DE FRANCE OLYMPIQUE ET PARALYMPIQUE RÊVE DE D…CROCHER UNE TRENTAINE DE M…DAILLES ¿ MILANO CORTINA 2026 AFIN DE SíINSTALLER DANS LE TOP 5 MONDIAL, QUATRE ANS AVANT LES JEUX DE 2030 « ¿ LA MAISON ».  Grand reporter à L’Équipe, Rachel Pretti est en charge des institutions sportives, notamment le CIO, l’IPC, le CNOSF, le CPSF, le ministère des Sports, ainsi que la présidence de la République. Elle travaille pour le groupe depuis 1999, d’abord à France Football, puis à L’Équipe depuis 2013. Dès 2015, elle a suivi de près l’aventure de Paris 2024, avant d’enchaîner avec celle des Alpes françaises 2030.  1 Éric Perrot, l’un des grands espoirs du biathlon, pourrait offrir à la France une médaille tant convoitée. 2 La reine des bosses Perrine Laffont a décroché son sixième titre mondial en 2025.  A  près la parenthèse enchantée des Jeux de Paris 2024, pendant laquelle les athlètes français ont décroché 64 médailles olympiques et 75 paralympiques, place au cirque blanc des Jeux d’hiver. L’équipe de France unifiée, comme son homologue d’été, s’est rassemblée cet automne dans le théâtre historique de la Gaîté Lyrique, à Paris, avant de s’éparpiller aux quatre coins du globe pour s’entraîner avant le lever de rideau olympique le 6 février. « La délégation française va être en force (…), ce sera la plus importante de notre histoire aux Jeux d’hiver », annonce Amélie OudéaCastéra, présidente du Comité National Olympique et Sportif Français (CNOSF) et ancienne ministre des Sports et des Jeux, soit entre 160 et 165 athlètes olympiques dont 45 % de femmes, « là aussi un record ». Un pourcentage proche de la parité, atteinte pour la première fois aux Jeux Olympiques de Paris 2024, qui doit beaucoup à la présence de l’équipe de France féminine de hockey sur glace, laquelle participe à ses premiers Jeux Olympiques. Les athlètes paralympiques sont moins nombreux, entre 15 et 18, mais avec une « immense responsabilité », rappelle l’octuple championne paralympique de ski alpin Marie Bochet, cheffe de mission paralympique qui était à leur place quatre ans auparavant. Car à délégation historique, objectif de médailles ambitieux. « Ce n’est pas une science exacte, mais on pense être en capacité de faire 50 % de médailles olympiques et paralympiques en plus par rapport aux Jeux de Beijing 2022 », se lance Yann Cucherat, ancien capitaine de l’équipe de France de  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "Revue Olympique  79  Numéro 125  gymnastique et manager de la haute performance au sein de l’Agence nationale du sport (ANS). Sachant que les tricolores ont ramené 14 médailles de la dernière édition des Jeux d’hiver en 2022, dont cinq en or, un rapide calcul fait monter la barre à 21. Et avec 12 médailles paralympiques, dont sept titres à Beijing, l’objectif monte à 18 breloques. « Ces Jeux, on les voit comme symboliquement forts car ce sont les premiers après les Jeux de Paris 2024 », insiste Amélie Oudéa-Castéra. La France vise ainsi, comme pendant l’été enchanté, le Top 5 au classement mondial des médailles olympiques et paralympiques, selon le cap fixé par le président de la République Emmanuel Macron au retour des Jeux de Tokyo en 2021. « On est en mission, on va représenter la France qui a besoin de confiance. L’objectif est de bien démarrer les Jeux », confirme Fabien Saguez, président de la Fédération française de ski et chef de la délégation olympique. Il compte évidemment sur les biathlètes pour démarrer le compteur, dans les traces de Justine Braisaz-Bouchet chez les femmes et d’Éric Perrot chez les hommes pour ne citer qu’eux. Les Bleus assument leur dépendance au biathlon dans la quête du graal olympique. « Il vaut mieux être biathlon dépendant que dépendant de rien, reconnaît Fabien Saguez. Après, on sait que sur l’ensemble des sites, on peut jouer les médailles ». Les biathlètes tricolores se sont entraînés en septembre sur le site d’Anterselva où 11 titres olympiques seront mis en jeu en février prochain. À Bormio, théâtre des épreuves de ski alpin, les regards seront tournés vers le skieur de Courchevel Alexis Pinturault. Après deux saisons gâchées par les blessures, le vainqueur du gros Globe en 2021 veut « vivre une expérience olympique en Europe », lors de ce qui devrait être son ultime hiver sur le circuit. Parce qu’à 34 ans, la médaille d’or olympique est la seule qui manque à son palmarès. Ce seront aussi les quatrièmes Jeux, mais sans doute pas les derniers, de Chloé Trespeuch, vice-championne olympique 2022 de snowboardcross. « Ces quatrièmes Jeux ont une saveur particulière », sourit la maman de Marlo, né en décembre 2024, qui sera du  voyage à Livigno avec son papa et une bonne partie de la famille. « L’or olympique est le rêve ultime. Mon expérience des précédents Jeux, couplée à l’immense bonheur d’être devenue maman et à la confiance engrangée avec le Globe de cristal [en 2024], sont mes plus grands atouts. Je me prépare avec plus d’envie et de sérénité que jamais pour représenter mon pays et aller chercher cette médaille », explique la pensionnaire du club de Val Thorens. Il faudra aussi compter sur la reine des bosses Perrine Laffont à Livigno. Après avoir fait l’impasse sur la saison 2023-2024 afin de préserver sa santé mentale, la championne olympique 2018 a confirmé son retour au sommet en décrochant un sixième titre de championne du monde des bosses en mars à Saint-Moritz, en Suisse. « Les derniers Jeux, c’était dans un contexte un peu anxiogène. J’aspire à des Jeux un peu plus légers. On va avoir la famille avec nous, ça va faire du bien à la tête », souligne la Pyrénéenne. Arthur Bauchet, triple champion paralympique de ski alpin à Beijing (2022) a déjà en tête la piste de Cortina d’Ampezzo. Le licencié du club de Briançon rêve d’y étoffer son palmarès de huit médailles paralympiques.  2  Les espoirs se portent enfin sur le nouveau couple formé par Guillaume Cizeron, champion olympique de danse sur glace à Beijing, et Laurence Fournier Beaudry. Vainqueur du Grand Prix de France à l’IceParc d’Angers le 19 octobre, le duo a subjugué les spectateurs et les juges lors du programme libre sur la bande originale du film The Whale. À la patinoire de Milan comme sur chacun des sites, Edgar Grospiron, président du comité d’organisation des Jeux Olympiques et Paralympiques des Alpes françaises 2030, ne comptera pas seulement les médailles. Il tirera les leçons des Jeux transalpins avant de ramener le drapeau le 23 février à Albertville. Afin d’écrire, avec toute son équipe, une autre page des Jeux d’hiver, les quatrièmes en France après Chamonix en 1924, Grenoble en 1968 et Albertville en 1992 où il a décroché l’or en ski de bosses. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 81-title\" style=\"top:100px;left:45px;\" src=\"/125/static/_content/81-title-1.png\"/>\n        <img class=\"abs halfScale 81-title\" style=\"top:167px;left:45px;\" src=\"/125/static/_content/81-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg81Anim = new TimelineMax();\n          pg81Anim.staggerFromTo(cOf(\"81-title\"), 0.9, {opacity:0, x:30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n        }\n          \n        function onPageLeave() {\n          pg81Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Revue Olympique  81  Numéro 125  DÉCÈS  Nous rendons hommage aux olympiens et personnalités du Mouvement olympique qui nous ont quittés.  PARK SUNG-SOO  LAURA DAHLMEiER  Archer champion olympique à Séoul en 1988 puis entraîneur, Park Sung-Soo nous a quittés à 55 ans. Sous le drapeau de la République de Corée, il s’est paré d’or en relais et d’argent en individuel, contribuant aux succès du pays hôte et à l’émergence de la domination de sa nation au tir à l’arc olympique. Après avoir raccroché le carcan, il est devenu l’un des entraîneurs les plus en vue du pays, guidant Oh Jin-hyek vers l’or en individuel hommes aux Jeux de Londres 2012, puis menant l’équipe olympique masculine sud-coréenne aux Jeux de Paris 2024, où Kim Woojin a aussi remporté le titre en individuel.  Première biathlète féminine à remporter les épreuves de sprint et de poursuite lors d’une même édition des Jeux Olympiques d’hiver Double championne olympique allemande de biathlon, Laura Dahlmeier nous a quittés à 31 ans à la suite d’un accident d’alpinisme sur le pic Laila, dans la chaîne de montagnes du Karakoram au Pakistan. Grâce à ses deux médailles d’or à PyeongChang 2018, elle est devenue la première biathlète de l’histoire à remporter une double victoire lors des épreuves de sprint et de poursuite lors d’une même édition des Jeux, tout en remportant le bronze en individuel. Au ﬁl de sa carrière, elle a empoché sept titres mondiaux et 15 médailles aux Championnats du monde entre 2015 et 2019, ainsi que le gros Globe de cristal en 2016/17. Après avoir raccroché les skis en 2019, Laura Dahlmeier s’est engagée dans les compétitions de course en montagne. Elle a également publié un livre pour enfants, travaillé comme consultante TV et œuvré comme bénévole pour l’équipe de secours en montagnes de Garmisch-Partenkirchen.  JOAN HARRiSON La nageuse sud-africaine Joan Harrison, première championne olympique de natation de son pays, est morte à 89 ans. Aux Jeux de l’Empire britannique de 1950 à Auckland (Nouvelle-Zélande), elle a battu de 13 secondes le record de la nage libre 440 yards pour remporter l’or. Deux ans plus tard, elle décrochait l’or olympique sur le 100 m dos aux Jeux d’Helsinki 1952, à seulement 16 ans. L’athlète a ensuite ajouté deux médailles d’or, une d’argent et deux de bronze aux Jeux de l’Empire britannique de 1954 à Vancouver (Canada), avant d’arrêter les compétitions internationales à l’âge de 17 ans.  NiNO BENVENUTi Le boxeur italien Nino Benvenuti, médaillé d’or olympique et champion du monde dans deux catégories de poids, nous a quittés à 87 ans. Sacré deux fois champion d’Europe, il avait ensuite remporté l’or des poids mi-moyens aux Jeux de Rome 1960. Passé professionnel, il a enregistré 65 victoires consécutives, gagnant les titres incontestés en poids super-welters et moyens.  CHARLES COSTE Le cycliste français Charles Coste, le plus ancien champion olympique au monde, est décédé à l’âge de 101 ans. Né à Ollioules (France) en 1924, il a remporté la médaille d’or en poursuite par équipes à Londres en 1948, aux côtés de ses coéquipiers Serge Blusson, Fernand Decanali et Pierre Adam – connus sous le nom d’équipe « ABCD ». Lors de la cérémonie d’ouverture des Jeux Olympiques de Paris 2024, Charles Coste a ému le monde en étant l’avant-dernière personne à porter la ﬂamme olympique."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": "82  Décès  LAMBiS V. NiKOLAOU Membre honoraire du CIO, acteur clé de la candidature réussie d’Athènes pour les Jeux Olympiques de 2004 Lambis V. Nikolaou, membre honoraire du CIO qui a consacré toute sa vie au Mouvement olympique, en Grèce et au-delà, est décédé à l’âge de 89 ans. Membre du CIO depuis 1986 et membre honoraire depuis 2016, il a exercé deux mandats en tant que président du Comité Olympique Hellénique de 1985 à 1992 puis de 1997 à 2004 et a siégé au comité exécutif des Comités Olympiques Européens de 1989 à 1993 et de 1997 à 2009. Figure majeure de la candidature d’Athènes pour les Jeux Olympiques de 2004, il a ensuite été nommé vice-président du comité d’organisation de cette édition historique des Jeux. En 2001, Lambis V. Nikolaou a été élu à la commission exécutive du CIO, puis a  HiTOMi OBARA Médaillée d’or et octuple championne du monde, la lutteuse japonaise Hitomi Obara est décédée à 44 ans. Née à Hachinohe, haut lieu de la lutte situé dans le nord du Japon, elle a remporté le titre en lutte libre dans la catégorie 48 kg à Londres 2012, après avoir précédemment dominé la catégorie 51 kg, avec six sacres mondiaux entre 2000 et 2008. Passée en 48 kg, elle a glané deux autres titres mondiaux en  occupé la fonction de vice-président du CIO entre 2005 et 2009. Il a également présidé la commission de la culture et de l’éducation olympique (2010–2015) ainsi que la commission de la culture et du patrimoine olympique (2015–2016) du CIO.  EMAM-ALi HABiBi 2010 et 2011, avant son instant de gloire à Londres 2012, battant au passage la championne olympique en titre, la Canadienne Carol Huynh. Forte de l’un des plus beaux palmarès des lutteuses japonaises, Hitomi Obara a quitté la compétition en 2013 puis a rejoint le staff technique national, devenant entraîneure de l’équipe nationale féminine. Elle a été intronisée au Temple de la renommée de la lutte mondiale en 2022.  Décédé à 94 ans, le lutteur Emam-Ali Habibi a été le tout premier champion olympique de l’Iran. Il avait remporté l’or en lutte libre dans la catégorie des 67 kg aux Jeux Olympiques de Melbourne 1956, devenant un héros national et posant les bases d’une longue tradition de succès olympiques pour son pays en lutte. Surnommé le « Tigre du Mazandaran », il a remporté trois titres mondiaux consécutifs entre 1959 et 1961, avant d’être intronisé au Temple de la renommée de la lutte mondiale en 2007.  ALEXANDRE DiTYATiN Triple champion olympique et premier athlète à décrocher des médailles dans huit épreuves masculines de gymnastique lors d’une même édition des Jeux, Alexandre Dityatin est décédé à l’âge de 67 ans. Représentant l’Union soviétique, il a établi ce record lors de Jeux Olympiques de Moscou 1980, en remportant trois médailles d’or, quatre d’argent et une de bronze, dont le concours général individuel. Septuple champion du monde, Alexandre Dityatin a également été le premier gymnaste masculin à obtenir la note parfaite de 10 aux Jeux Olympiques et a été intronisé au Temple international de la renommée de la gymnastique en 2004."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n          \n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'addContentLinkThree'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay = 1, stagger = 0.3) {\n        numbers = cOf(klass)\n\n        setTimeout(function() {\n          for (let i = 0; i < numbers.length; i++) {\n            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])\n          }\n        }, delay * 1000)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-78Q0TXTNZY" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dUvF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wc2M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8740320dd9b8627b0b5c.js